
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("7om8k", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");











var $8C5kA = parcelRequire("8C5kA");


var $esRft = parcelRequire("esRft");


var $3gadb = parcelRequire("3gadb");


var $lGgRw = parcelRequire("lGgRw");


var $dcJ7R = parcelRequire("dcJ7R");

var $2W0qg = parcelRequire("2W0qg");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");


var $jmjWc = parcelRequire("jmjWc");


var $ep3mz = parcelRequire("ep3mz");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $9wGTI = parcelRequire("9wGTI");


var $eToX6 = parcelRequire("eToX6");


var $kuujH = parcelRequire("kuujH");


var $jFm04 = parcelRequire("jFm04");


var $2zphh = parcelRequire("2zphh");








var $2XqLN = parcelRequire("2XqLN");

const $de8876e797e08e86$export$376d7d7a8afb5e40 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const [createDuplicateRef] = (0, $42omo.useState)($de8876e797e08e86$var$_temp2);
    return createDuplicateRef;
} : ()=>{
    const [createDuplicateRef] = (0, $42omo.useState)(()=>(0, $2XqLN.default)((ref, setDuplicatedRef)=>{
            return (node)=>{
                if (typeof ref === 'function') ref(node);
                else if (ref) ref.current = node;
                setDuplicatedRef({
                    current: node
                });
            };
        }));
    return createDuplicateRef;
};
function $de8876e797e08e86$var$_temp(ref, setDuplicatedRef) {
    return (node)=>{
        if (typeof ref === "function") ref(node);
        else if (ref) ref.current = node;
        setDuplicatedRef({
            current: node
        });
    };
}
function $de8876e797e08e86$var$_temp2() {
    return (0, $2XqLN.default)($de8876e797e08e86$var$_temp);
}



const $a1b50edf1fd86d1e$var$LazyPopupContent = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "_Qz_k",
    name: "LazyPopupContent",
    loader: async ()=>(await (parcelRequire("cwMhG"))).PageOwnershipByLineWithContributorsDropdownContent
});
const $a1b50edf1fd86d1e$var$triggerStyles = (0, $ecnYn.xcss)({
    borderRadius: 'radius.small',
    paddingInline: 'space.050',
    paddingBlock: 'space.025',
    backgroundColor: 'color.background.neutral.subtle',
    textOverflow: 'ellipsis',
    whiteSpace: 'normal',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed'
    }
});
const $a1b50edf1fd86d1e$var$previewPanelCardStyle = (0, $ecnYn.xcss)({
    paddingInline: 'space.050',
    paddingBlock: 'space.025',
    textOverflow: 'ellipsis',
    whiteSpace: 'normal'
});
const $a1b50edf1fd86d1e$var$PageOwnershipByLineWithContributorsDropdownComponent = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(37);
    const { owner: owner, author: author, contributorCountWithoutOwner: contributorCountWithoutOwner, analyticsSource: analyticsSource, generatedBy: generatedBy } = t0;
    const intl = (0, $8C5kA.default)();
    const { openModal: openChangeOwnerModal } = (0, $jFm04.useContentOwnershipContext)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [isDropdownOpen, setIsDropdownOpen] = (0, $42omo.useState)(false);
    const [triggerRefDuplicate, setTriggerRefDuplicate] = (0, $42omo.useState)(null);
    const createDuplicateRef = (0, $de8876e797e08e86$export$376d7d7a8afb5e40)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            setIsDropdownOpen(false);
        };
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== contentId) {
        t2 = [
            contentId
        ];
        $[1] = contentId;
        $[2] = t2;
    } else t2 = $[2];
    (0, $42omo.useEffect)(t1, t2);
    const pageOwner = owner ?? author;
    let t3;
    if ($[3] !== pageOwner) {
        t3 = (0, $2zphh.getUserAvatarSrc)(pageOwner);
        $[3] = pageOwner;
        $[4] = t3;
    } else t3 = $[4];
    const avatarSrc = t3;
    const profileCardResidesInPreviewPanel = (0, $9wGTI.fg)("confluence_profilecard_preview_panel_support") ? (0, $eToX6.isInPreviewPanel)() : false;
    let t4;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = ()=>{
            setIsDropdownOpen($a1b50edf1fd86d1e$var$_temp);
        };
        $[5] = t4;
    } else t4 = $[5];
    const onPopupTriggerClick = t4;
    let t5;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = ()=>{
            setIsDropdownOpen(false);
        };
        $[6] = t5;
    } else t5 = $[6];
    const onPopupClose = t5;
    let t6;
    if ($[7] !== openChangeOwnerModal || $[8] !== triggerRefDuplicate) {
        t6 = ()=>{
            openChangeOwnerModal({
                returnFocusRef: triggerRefDuplicate ?? undefined
            });
            setIsDropdownOpen(false);
        };
        $[7] = openChangeOwnerModal;
        $[8] = triggerRefDuplicate;
        $[9] = t6;
    } else t6 = $[9];
    const onChangeOwnerClick = t6;
    let t7;
    if ($[10] !== avatarSrc) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), {
            src: avatarSrc,
            borderColor: "transparent",
            size: "xsmall"
        });
        $[10] = avatarSrc;
        $[11] = t7;
    } else t7 = $[11];
    let t8;
    if ($[12] !== generatedBy || $[13] !== intl || $[14] !== pageOwner.fullName) {
        t8 = intl.formatMessage(generatedBy === "ONBOARDING" ? (0, $kuujH.i18n).bylineMainTextCreatedByConfluence : (0, $kuujH.i18n).abbreviatedBylineMainText, {
            user: pageOwner.fullName
        });
        $[12] = generatedBy;
        $[13] = intl;
        $[14] = pageOwner.fullName;
        $[15] = t8;
    } else t8 = $[15];
    let t9;
    if ($[16] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
            size: "small",
            color: "color.text.subtle",
            maxLines: 1
        }, t8);
        $[16] = t8;
        $[17] = t9;
    } else t9 = $[17];
    let t10;
    if ($[18] !== t7 || $[19] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
            space: "space.050",
            alignBlock: "center",
            xcss: $a1b50edf1fd86d1e$var$previewPanelCardStyle
        }, t7, t9);
        $[18] = t7;
        $[19] = t9;
        $[20] = t10;
    } else t10 = $[20];
    const ownerInfoInsidePreviewPanel = t10;
    let t11;
    if ($[21] !== avatarSrc || $[22] !== createDuplicateRef || $[23] !== generatedBy || $[24] !== intl || $[25] !== isDropdownOpen || $[26] !== pageOwner.fullName) {
        t11 = (t12)=>{
            const { ref: ref, ...triggerProps } = t12;
            const triggerRef = createDuplicateRef(ref, setTriggerRefDuplicate);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
                content: isDropdownOpen ? undefined : intl.formatMessage((0, $kuujH.i18n).ownerWithContributorsDropdownTooltip),
                position: "bottom",
                hideTooltipOnClick: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
                testId: "owner-with-contributors-dropdown-trigger",
                xcss: $a1b50edf1fd86d1e$var$triggerStyles,
                onClick: onPopupTriggerClick,
                ref: triggerRef,
                ...triggerProps
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
                space: "space.050",
                alignBlock: "center"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), {
                src: avatarSrc,
                borderColor: "transparent",
                size: "xsmall"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
                size: "small",
                color: "color.text.subtle",
                maxLines: 1
            }, intl.formatMessage(generatedBy === "ONBOARDING" ? (0, $kuujH.i18n).bylineMainTextCreatedByConfluence : (0, $kuujH.i18n).abbreviatedBylineMainText, {
                user: pageOwner.fullName
            })))));
        };
        $[21] = avatarSrc;
        $[22] = createDuplicateRef;
        $[23] = generatedBy;
        $[24] = intl;
        $[25] = isDropdownOpen;
        $[26] = pageOwner.fullName;
        $[27] = t11;
    } else t11 = $[27];
    const popupTrigger = t11;
    if (profileCardResidesInPreviewPanel) return ownerInfoInsidePreviewPanel;
    let t12;
    if ($[28] !== analyticsSource || $[29] !== contributorCountWithoutOwner || $[30] !== onChangeOwnerClick || $[31] !== pageOwner) {
        t12 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a1b50edf1fd86d1e$var$LazyPopupContent, {
                analyticsSource: `${analyticsSource}-byline`,
                owner: pageOwner,
                onChangeOwnerClick: onChangeOwnerClick,
                contributorCountWithoutOwner: contributorCountWithoutOwner
            });
        $[28] = analyticsSource;
        $[29] = contributorCountWithoutOwner;
        $[30] = onChangeOwnerClick;
        $[31] = pageOwner;
        $[32] = t12;
    } else t12 = $[32];
    let t13;
    if ($[33] !== isDropdownOpen || $[34] !== popupTrigger || $[35] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
            content: t12,
            trigger: popupTrigger,
            isOpen: isDropdownOpen,
            onClose: onPopupClose,
            placement: "bottom-start"
        });
        $[33] = isDropdownOpen;
        $[34] = popupTrigger;
        $[35] = t12;
        $[36] = t13;
    } else t13 = $[36];
    return t13;
} : ({ owner: owner, author: author, contributorCountWithoutOwner: contributorCountWithoutOwner, analyticsSource: analyticsSource, generatedBy: generatedBy })=>{
    const intl = (0, $8C5kA.default)();
    const { openModal: openChangeOwnerModal } = (0, $jFm04.useContentOwnershipContext)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [isDropdownOpen, setIsDropdownOpen] = (0, $42omo.useState)(false);
    const [triggerRefDuplicate, setTriggerRefDuplicate] = (0, $42omo.useState)(null);
    const createDuplicateRef = (0, $de8876e797e08e86$export$376d7d7a8afb5e40)();
    // Reset state when changing contentId
    (0, $42omo.useEffect)(()=>{
        setIsDropdownOpen(false);
    }, [
        contentId
    ]);
    const pageOwner = owner ?? author;
    const avatarSrc = (0, $2zphh.getUserAvatarSrc)(pageOwner);
    const profileCardResidesInPreviewPanel = (0, $9wGTI.fg)('confluence_profilecard_preview_panel_support') ? (0, $eToX6.isInPreviewPanel)() : false;
    const onPopupTriggerClick = (0, $42omo.useCallback)(()=>{
        setIsDropdownOpen((prev)=>!prev);
    }, []);
    const onPopupClose = (0, $42omo.useCallback)(()=>{
        setIsDropdownOpen(false);
    }, []);
    const onChangeOwnerClick = (0, $42omo.useCallback)(()=>{
        // accessibility: return focus to dropdown trigger when change owner modal closes - doesnt happen automatically because the change owner modal trigger is in the dropdown which gets unmounted when the modal opens.
        openChangeOwnerModal({
            returnFocusRef: triggerRefDuplicate ?? undefined
        });
        setIsDropdownOpen(false);
    }, [
        openChangeOwnerModal,
        triggerRefDuplicate
    ]);
    const ownerInfoInsidePreviewPanel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        space: "space.050",
        alignBlock: "center",
        xcss: $a1b50edf1fd86d1e$var$previewPanelCardStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), {
        src: avatarSrc,
        borderColor: "transparent",
        size: "xsmall"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        size: "small",
        color: "color.text.subtle",
        maxLines: 1
    }, intl.formatMessage(generatedBy === 'ONBOARDING' ? (0, $kuujH.i18n).bylineMainTextCreatedByConfluence : (0, $kuujH.i18n).abbreviatedBylineMainText, {
        user: pageOwner.fullName
    })));
    const popupTrigger = ({ ref: ref, ...triggerProps })=>{
        const triggerRef = createDuplicateRef(ref, setTriggerRefDuplicate);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: isDropdownOpen ? undefined : intl.formatMessage((0, $kuujH.i18n).ownerWithContributorsDropdownTooltip),
            position: "bottom",
            hideTooltipOnClick: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
            testId: "owner-with-contributors-dropdown-trigger",
            xcss: $a1b50edf1fd86d1e$var$triggerStyles,
            onClick: onPopupTriggerClick,
            ref: triggerRef,
            ...triggerProps
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
            space: "space.050",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), {
            src: avatarSrc,
            borderColor: "transparent",
            size: "xsmall"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
            size: "small",
            color: "color.text.subtle",
            maxLines: 1
        }, intl.formatMessage(generatedBy === 'ONBOARDING' ? (0, $kuujH.i18n).bylineMainTextCreatedByConfluence : (0, $kuujH.i18n).abbreviatedBylineMainText, {
            user: pageOwner.fullName
        })))));
    };
    if (profileCardResidesInPreviewPanel) return ownerInfoInsidePreviewPanel;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a1b50edf1fd86d1e$var$LazyPopupContent, {
                analyticsSource: `${analyticsSource}-byline`,
                owner: pageOwner,
                onChangeOwnerClick: onChangeOwnerClick,
                contributorCountWithoutOwner: contributorCountWithoutOwner
            }),
        trigger: popupTrigger,
        isOpen: isDropdownOpen,
        onClose: onPopupClose,
        placement: "bottom-start"
    });
};
const $a1b50edf1fd86d1e$export$4f664a3a9881436 = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).PAGE_EXPERIENCES
})((0, $jFm04.withContentOwnershipContextProvider)($a1b50edf1fd86d1e$var$PageOwnershipByLineWithContributorsDropdownComponent));
function $a1b50edf1fd86d1e$var$_temp(prev) {
    return !prev;
}


const $a7795cfffaaaa1a7$export$a976a35f73cf7a61 = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $frIzR.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a1b50edf1fd86d1e$export$4f664a3a9881436), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a1b50edf1fd86d1e$export$4f664a3a9881436), props);
};
module.exports["BadgeStylePageOwnershipByline"] = $a7795cfffaaaa1a7$export$a976a35f73cf7a61;

});

parcelRegister("2zphh", function(module, exports) {
const $bf70d92172ad781d$export$eae7710ac4f92e1b = (user)=>{
    return user.isAnonymous || !user.avatarUrl ? undefined : user.avatarUrl;
};
module.exports["getUserAvatarSrc"] = $bf70d92172ad781d$export$eae7710ac4f92e1b;

});

parcelRegister("cwMhG", function(module, exports) {

let $91eded6f142d10cb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $91eded6f142d10cb$var$load("6wr18"),
    $91eded6f142d10cb$var$load("ffEVr"),
    $91eded6f142d10cb$var$load("cWvhX")
]).then(()=>parcelRequire('8M3ga'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("5UrgY", function(module, exports) {
/**
 * @generated SignedSource<<ed620a8da1457ce1e1918bd20c68212b>>
 * @relayHash 2103c53d735f991e490d064c47f4e477
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID be855f802987ae713ce771a2def749f914ce00b7a493b56b29d8bc0d4b823c39
const $39b308dfbd9fe211$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "accountIds"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentIds"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "endTime"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "startTime"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "accountIds",
                    "variableName": "accountIds"
                },
                {
                    "kind": "Variable",
                    "name": "contentIds",
                    "variableName": "contentIds"
                },
                {
                    "kind": "Variable",
                    "name": "endTime",
                    "variableName": "endTime"
                },
                {
                    "kind": "Variable",
                    "name": "startTime",
                    "variableName": "startTime"
                }
            ],
            "concreteType": "ContentAnalyticsLastViewedAtByPage",
            "kind": "LinkedField",
            "name": "contentAnalyticsLastViewedAtByPage",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ContentAnalyticsLastViewedAtByPageItem",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "contentId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "lastViewedAt"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useIsEligibleReactionsFeedbackPageReturnGetUserLastViewedQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useIsEligibleReactionsFeedbackPageReturnGetUserLastViewedQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "2103c53d735f991e490d064c47f4e477",
            "id": "be855f802987ae713ce771a2def749f914ce00b7a493b56b29d8bc0d4b823c39",
            "metadata": {},
            "name": "useIsEligibleReactionsFeedbackPageReturnGetUserLastViewedQuery",
            "operationKind": "query",
            "text": "query useIsEligibleReactionsFeedbackPageReturnGetUserLastViewedQuery($contentIds:[ID!]!,$startTime:String!,$endTime:String,$accountIds:[ID!]){contentAnalyticsLastViewedAtByPage(contentIds:$contentIds,startTime:$startTime,endTime:$endTime,accountIds:$accountIds){nodes{contentId,lastViewedAt}}}"
        }
    };
}();
$39b308dfbd9fe211$var$node.hash = "38710c79bd60dde8a74c9adbe1cc64cc";
var $39b308dfbd9fe211$export$2e2bcd8739ae039 = $39b308dfbd9fe211$var$node;


/**
 * @generated SignedSource<<52221207e921c6ab425a2ee6dee40278>>
 * @relayHash 6ba4246d568f662506bcf5f862b52c70
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 307eae256f3e7eed97f541ec200ad12843f4e5a3262b4a2a5f5aa7176285b303
const $2e8acd0a701661bd$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "pageId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "startTime"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "eventName",
                    "value": [
                        "reaction_created"
                    ]
                },
                {
                    "kind": "Literal",
                    "name": "limit",
                    "value": 1
                },
                {
                    "kind": "Variable",
                    "name": "pageId",
                    "variableName": "pageId"
                },
                {
                    "kind": "Variable",
                    "name": "startTime",
                    "variableName": "startTime"
                }
            ],
            "concreteType": "CountGroupByPage",
            "kind": "LinkedField",
            "name": "countGroupByPage",
            "plural": false,
            "selections": [
                {
                    "concreteType": "CountGroupByPageItem",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "count"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "page"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useIsEligibleReactionsFeedbackPageReturnReactionCountByTimeQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useIsEligibleReactionsFeedbackPageReturnReactionCountByTimeQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "6ba4246d568f662506bcf5f862b52c70",
            "id": "307eae256f3e7eed97f541ec200ad12843f4e5a3262b4a2a5f5aa7176285b303",
            "metadata": {},
            "name": "useIsEligibleReactionsFeedbackPageReturnReactionCountByTimeQuery",
            "operationKind": "query",
            "text": "query useIsEligibleReactionsFeedbackPageReturnReactionCountByTimeQuery($pageId:[ID!]!,$startTime:String!){countGroupByPage(pageId:$pageId,startTime:$startTime,eventName:[reaction_created],limit:1){nodes{count,page}}}"
        }
    };
}();
$2e8acd0a701661bd$var$node.hash = "e0f215e969dd8fe8e354bb8df118ce2f";
var $2e8acd0a701661bd$export$2e2bcd8739ae039 = $2e8acd0a701661bd$var$node;



var $42omo = parcelRequire("42omo");


var $bQm3c = parcelRequire("bQm3c");


var $jMyy4 = parcelRequire("jMyy4");


var $6mKj3 = parcelRequire("6mKj3");

const $7910f877b0049356$var$countReactionsByTime = (0, $2e8acd0a701661bd$export$2e2bcd8739ae039);
const $7910f877b0049356$var$getUserLastViewed = (0, $39b308dfbd9fe211$export$2e2bcd8739ae039);
const $7910f877b0049356$export$5652ebafb48694f = ({ contentId: contentId, isContributor: isContributor, skip: skip = false })=>{
    const thirtyDaysAgo = (0, $42omo.useMemo)(()=>{
        const date = new Date();
        date.setDate(date.getDate() - 30);
        return date.toISOString();
    }, []);
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const shouldRunUserLastViewedQuery = isContributor && !skip && userId;
    const { data: userLastViewedData, loading: userLastViewedLoading, error: userLastViewedError } = (0, $jMyy4.useQueryInterop)($7910f877b0049356$var$getUserLastViewed, {
        variables: {
            contentIds: [
                contentId
            ],
            startTime: thirtyDaysAgo,
            accountIds: userId ? [
                userId
            ] : []
        },
        skip: !shouldRunUserLastViewedQuery
    });
    const lastViewedAt = (0, $42omo.useMemo)(()=>{
        return userLastViewedData?.contentAnalyticsLastViewedAtByPage?.nodes?.[0]?.lastViewedAt;
    }, [
        userLastViewedData
    ]);
    const isLastViewedInSameHour = (0, $42omo.useMemo)(()=>{
        if (!lastViewedAt) return false;
        const lastViewed = new Date(lastViewedAt);
        const now = new Date();
        return lastViewed.getFullYear() === now.getFullYear() && lastViewed.getMonth() === now.getMonth() && lastViewed.getDate() === now.getDate() && lastViewed.getHours() === now.getHours();
    }, [
        lastViewedAt
    ]);
    const shouldRunReactionCountQuery = Boolean(shouldRunUserLastViewedQuery && !userLastViewedLoading && !userLastViewedError && !isLastViewedInSameHour);
    const reactionQueryStartTime = lastViewedAt || thirtyDaysAgo;
    const { data: countReactionByTimeData, loading: countReactionByTimeLoading, error: countReactionByTimeError } = (0, $jMyy4.useQueryInterop)($7910f877b0049356$var$countReactionsByTime, {
        variables: {
            pageId: [
                contentId
            ],
            startTime: reactionQueryStartTime
        },
        skip: !shouldRunReactionCountQuery
    });
    const isLoading = countReactionByTimeLoading || userLastViewedLoading;
    const allErrors = countReactionByTimeError || userLastViewedError;
    const isEligible = (0, $42omo.useMemo)(()=>{
        if (skip || !isContributor) return false;
        if (isLoading || allErrors) return false;
        const reactionCount = countReactionByTimeData?.countGroupByPage?.nodes?.[0]?.count || 0;
        if (reactionCount <= 0) return false;
        // Fire AA exposure for eligible users
        (0, $6mKj3.expValEquals)('cc_engagement_reactions_feedback_page_return_aa', 'cohort', 'control');
        // Check experiment cohort
        // Given this experiment is fired from both Live Page and
        // Regular Page, from two different code path, we check
        // experiment flag in eligiblity hook.
        return (0, $6mKj3.expValEquals)('cc-engagement-reactions-feedback-page-return-exp', 'cohort', 'experiment');
    }, [
        countReactionByTimeData,
        skip,
        isContributor,
        isLoading,
        allErrors
    ]);
    return {
        isEligible: isEligible,
        loading: isLoading,
        error: allErrors
    };
};
module.exports["useIsEligibleReactionsFeedbackPageReturn"] = $7910f877b0049356$export$5652ebafb48694f;

});

parcelRegister("fImWv", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $da002f83cf061f88$export$d0aef4d352cf8b14 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "ctj29",
    name: "AnalyticsByLine",
    loader: async ()=>(await (parcelRequire("hDrjP"))).AnalyticsByLine
});
module.exports["AnalyticsByLine"] = $da002f83cf061f88$export$d0aef4d352cf8b14;

});

parcelRegister("hDrjP", function(module, exports) {

let $cd6b451f0ce5b42f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $cd6b451f0ce5b42f$var$load("eylda"),
    $cd6b451f0ce5b42f$var$load("8TDGF"),
    $cd6b451f0ce5b42f$var$load("7Ya0F"),
    $cd6b451f0ce5b42f$var$load("hOaAV"),
    $cd6b451f0ce5b42f$var$load("8UKe0"),
    $cd6b451f0ce5b42f$var$load("cEqm7"),
    $cd6b451f0ce5b42f$var$load("6XCf4"),
    $cd6b451f0ce5b42f$var$load("7EorR"),
    $cd6b451f0ce5b42f$var$load("5pvpJ"),
    $cd6b451f0ce5b42f$var$load("hhss7"),
    $cd6b451f0ce5b42f$var$load("1qlDN"),
    $cd6b451f0ce5b42f$var$load("1yVM6"),
    $cd6b451f0ce5b42f$var$load("6c9wI")
]).then(()=>parcelRequire('ffp8s'));

});

parcelRegister("a9SX7", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $db22052f45cd3c08$export$aeb07f2d59756a1b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "VfqBC",
    name: "ListenByline",
    loader: async ()=>(await (parcelRequire("hi5jb"))).ListenByline
});
module.exports["ListenByline"] = $db22052f45cd3c08$export$aeb07f2d59756a1b;

});

parcelRegister("hi5jb", function(module, exports) {

let $c9683c437fba6b1d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c9683c437fba6b1d$var$load("3R2Cd"),
    $c9683c437fba6b1d$var$load("44eor"),
    $c9683c437fba6b1d$var$load("8faeS"),
    $c9683c437fba6b1d$var$load("4dNRa"),
    $c9683c437fba6b1d$var$load("5lo9L")
]).then(()=>parcelRequire('lFyOr'));

});

parcelRegister("AavAW", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $bUlM5 = parcelRequire("bUlM5");

var $ecnYn = parcelRequire("ecnYn");


var $kevJM = parcelRequire("kevJM");

const $5783a7702ddb8025$var$loadingStyle = (0, $ecnYn.xcss)({
    width: '85px',
    backgroundColor: 'color.skeleton.subtle',
    height: '24px',
    borderRadius: 'radius.full'
});
const $5783a7702ddb8025$var$lastUpdateStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.025',
    marginLeft: 'space.100',
    marginRight: 'space.150'
});
const $5783a7702ddb8025$var$i18n = (0, $cgtv4.defineMessages)({
    lastUpdateIconLabel: {
        id: "content-header.by-line.live-pages.last.updated.icon.label",
        defaultMessage: "Last updated"
    }
});
const $5783a7702ddb8025$export$b76f09da983efdc2 = /*#__PURE__*/ (0, $42omo.memo)((t0)=>{
    const $ = (0, $frIzR.c)(10);
    const { version: version, loading: loading } = t0;
    const intl = (0, $8C5kA.default)();
    let t1;
    if ($[0] !== intl) {
        t1 = intl.formatMessage($5783a7702ddb8025$var$i18n.lastUpdateIconLabel);
        $[0] = intl;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kevJM))), {
            label: t1,
            color: "var(--ds-text-subtle, #505258)",
            testId: "last-updated-icon"
        });
        $[2] = t1;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== loading || $[5] !== version) {
        t3 = loading && !version.friendlyWhen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
            xcss: $5783a7702ddb8025$var$loadingStyle,
            alignItems: "center",
            justifyContent: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null)) : version?.friendlyWhen;
        $[4] = loading;
        $[5] = version;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== t2 || $[8] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
            alignItems: "center",
            gap: "space.075",
            xcss: $5783a7702ddb8025$var$lastUpdateStyles,
            testId: "live-page-last-updated"
        }, t2, t3);
        $[7] = t2;
        $[8] = t3;
        $[9] = t4;
    } else t4 = $[9];
    return t4;
});
module.exports["ByLineLastUpdatedCompact"] = $5783a7702ddb8025$export$b76f09da983efdc2;

});

parcelRegister("aKxcs", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $eSUdr = parcelRequire("eSUdr");


var $jMyy4 = parcelRequire("jMyy4");


var $cuWTe = parcelRequire("cuWTe");


var $1ggpj = parcelRequire("1ggpj");


var $iiPY2 = parcelRequire("iiPY2");


var $knzfV = parcelRequire("knzfV");


var $1u6lx = parcelRequire("1u6lx");


var $bFMG7 = parcelRequire("bFMG7");


var $b3j2Y = parcelRequire("b3j2Y");


var $6S5EB = parcelRequire("6S5EB");


var $cD1qu = parcelRequire("cD1qu");


var $aSsfA = parcelRequire("aSsfA");


var $9wGTI = parcelRequire("9wGTI");

const $5278cea226e8a354$export$5dc05a3e9ee4399c = (t0)=>{
    const $ = (0, $frIzR.c)(30);
    const { contentId: contentId } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $eSUdr.default)`query BylineClassificationQuery($contentId:ID){content(id:$contentId status:["archived" "current" "draft"]){nodes{id title operations{operation targetType}space{id name key alias}type status}}}`;
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== contentId) {
        t2 = {
            variables: {
                contentId: contentId
            }
        };
        $[1] = contentId;
        $[2] = t2;
    } else t2 = $[2];
    const { data: data, error: BylineClassificationQueryError } = (0, $jMyy4.useQueryInterop)(t1, t2);
    const contentData = data?.content?.nodes?.[0];
    const spaceKey = contentData?.space?.key || "";
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $6S5EB.isExternalShareRequest)();
        $[3] = t3;
    } else t3 = $[3];
    const isExternal = t3;
    const rawContentType = contentData?.type ?? undefined;
    const isArchived = contentData?.status === "archived";
    const isDraft = contentData?.status === "draft";
    const isViewEditOrLive = (0, $aSsfA.useGetPageMode)();
    let t4;
    if ($[4] !== isArchived || $[5] !== isDraft || $[6] !== isViewEditOrLive || $[7] !== rawContentType) {
        t4 = (0, $cuWTe.getContentMode)(rawContentType, isArchived, isDraft, isViewEditOrLive);
        $[4] = isArchived;
        $[5] = isDraft;
        $[6] = isViewEditOrLive;
        $[7] = rawContentType;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== rawContentType || $[10] !== t4) {
        t5 = {
            type: rawContentType,
            mode: t4
        };
        $[9] = rawContentType;
        $[10] = t4;
        $[11] = t5;
    } else t5 = $[11];
    const contentType = t5;
    let contentStatusContext;
    if (contentType.mode === "live" || contentType.mode === (0, $cD1qu.PageMode).VIEW && (0, $9wGTI.fg)("dlp_classification_access")) contentStatusContext = "current-and-draft";
    else if (contentType.mode === "edit" || contentType.mode === "draft") contentStatusContext = "draft-only";
    else contentStatusContext = "current-only";
    let t6;
    if ($[12] !== contentType.mode) {
        t6 = contentType.mode === (0, $cD1qu.PageMode).VIEW && !(0, $9wGTI.fg)("dlp_classification_access");
        $[12] = contentType.mode;
        $[13] = t6;
    } else t6 = $[13];
    const isViewModeReadOnly = t6;
    const t7 = contentData?.space?.key;
    let t8;
    if ($[14] !== contentId || $[15] !== contentStatusContext || $[16] !== t7) {
        t8 = {
            contentId: contentId,
            spaceKeyOverride: t7,
            contentStatusContext: contentStatusContext,
            shouldReadFromQueries: true
        };
        $[14] = contentId;
        $[15] = contentStatusContext;
        $[16] = t7;
        $[17] = t8;
    } else t8 = $[17];
    const contentClassificationMetadata = (0, $bFMG7.useContentClassification)(t8);
    let t9;
    if ($[18] !== contentClassificationMetadata || $[19] !== contentData?.operations) {
        t9 = (0, $9wGTI.fg)("dlp_classification_access") ? contentClassificationMetadata.isReclassificationPermitted ?? false : contentData?.operations?.some($5278cea226e8a354$var$_temp);
        $[18] = contentClassificationMetadata;
        $[19] = contentData?.operations;
        $[20] = t9;
    } else t9 = $[20];
    const hasUpdatePermission = t9;
    const readOnly = isExternal || !hasUpdatePermission || isViewModeReadOnly;
    if (BylineClassificationQueryError) {
        let t10;
        if ($[21] !== BylineClassificationQueryError) {
            t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
                error: BylineClassificationQueryError
            });
            $[21] = BylineClassificationQueryError;
            $[22] = t10;
        } else t10 = $[22];
        return t10;
    }
    const isClassificationEnabled = contentClassificationMetadata?.featureEnabled ?? false;
    let t10;
    if ($[23] !== contentClassificationMetadata || $[24] !== contentId || $[25] !== contentType.type || $[26] !== isClassificationEnabled || $[27] !== readOnly || $[28] !== spaceKey) {
        t10 = isClassificationEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iiPY2.ContentTypeClassificationLoader), {
            variant: (0, $1u6lx.TagButtonUIVariant).default,
            spaceKey: spaceKey,
            contentId: contentId,
            contentType: contentType.type ?? "",
            contentClassificationMetadata: contentClassificationMetadata,
            readOnly: readOnly,
            spacing: "expanded"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $knzfV.ClassificationEditModal), {
            contentId: contentId,
            spaceKey: spaceKey,
            contentClassificationMetadata: contentClassificationMetadata
        })) : null;
        $[23] = contentClassificationMetadata;
        $[24] = contentId;
        $[25] = contentType.type;
        $[26] = isClassificationEnabled;
        $[27] = readOnly;
        $[28] = spaceKey;
        $[29] = t10;
    } else t10 = $[29];
    return t10;
};
function $5278cea226e8a354$var$_temp(operation) {
    return operation?.targetType && (0, $1ggpj.VALID_OPERATION_TARGETS).includes(operation?.targetType) && operation?.operation === "update";
}
module.exports["BylineClassification"] = $5278cea226e8a354$export$5dc05a3e9ee4399c;

});

parcelRegister("6iOCg", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $8Yfbq = parcelRequire("8Yfbq");


var $bUlM5 = parcelRequire("bUlM5");

var $ecnYn = parcelRequire("ecnYn");


var $4JDbp = parcelRequire("4JDbp");


var $jVylI = parcelRequire("jVylI");


var $aV3a0 = parcelRequire("aV3a0");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $6S5EB = parcelRequire("6S5EB");


var $gektR = parcelRequire("gektR");


var $e4o8D = parcelRequire("e4o8D");





var $7Ndnw = parcelRequire("7Ndnw");


var $3b6WO = parcelRequire("3b6WO");


var $eSLr0 = parcelRequire("eSLr0");


var $6ld6a = parcelRequire("6ld6a");

const $e105dde0a43b3be2$export$b613c53a0aeac846 = (contentId)=>{
    const $ = (0, $frIzR.c)(10);
    let t0;
    if ($[0] !== contentId) {
        t0 = {
            contentId: contentId,
            location: (0, $eSLr0.SYSTEM_CONTENT_BYLINE)
        };
        $[0] = contentId;
        $[1] = t0;
    } else t0 = $[1];
    const { webItems: connectItems, loading: loadingConnectItems } = (0, $6ld6a.useWebItemLocation)(t0);
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            moduleType: (0, $7Ndnw.FORGE_MODULE_BYLINE)
        };
        $[2] = t1;
    } else t1 = $[2];
    const { extensions: forgeItems, loading: loadingForgeItems, error: forgeError } = (0, $3b6WO.useExtensionList)(t1);
    const t2 = connectItems?.length > 0 || forgeItems?.length > 0;
    let t3;
    if ($[3] !== connectItems || $[4] !== forgeError || $[5] !== forgeItems || $[6] !== loadingConnectItems || $[7] !== loadingForgeItems || $[8] !== t2) {
        t3 = {
            hasApps: t2,
            connectItems: connectItems,
            loadingConnectItems: loadingConnectItems,
            forgeItems: forgeItems,
            loadingForgeItems: loadingForgeItems,
            forgeError: forgeError
        };
        $[3] = connectItems;
        $[4] = forgeError;
        $[5] = forgeItems;
        $[6] = loadingConnectItems;
        $[7] = loadingForgeItems;
        $[8] = t2;
        $[9] = t3;
    } else t3 = $[9];
    return t3;
};



var $j2moL = parcelRequire("j2moL");


var $35Exc = parcelRequire("35Exc");








var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $laHi9 = parcelRequire("laHi9");


var $6R5uz = parcelRequire("6R5uz");


var $1qfLF = parcelRequire("1qfLF");


var $6f0Oj = parcelRequire("6f0Oj");

var $2W0qg = parcelRequire("2W0qg");



const $120e402a2d601a31$var$i18n = (0, $cgtv4.defineMessages)({
    showAllApps: {
        id: "content-header.livepages.by-line.showAllApps",
        defaultMessage: "Show all apps"
    },
    showLessApps: {
        id: "content-header.livepages.by-line.showLess",
        defaultMessage: "Show less"
    }
});
const $120e402a2d601a31$var$toggleButtonGradientStyles = (0, $ecnYn.xcss)({
    height: '100%',
    position: 'relative',
    '::before': {
        content: '""',
        background: `linear-gradient(to right, transparent, ${"var(--ds-surface, #FFFFFF)"})`,
        height: '100%',
        left: 'space.negative.400',
        position: 'absolute',
        width: '32px'
    }
});
const $120e402a2d601a31$var$buttonStyles = (0, $ecnYn.xcss)({
    alignItems: 'center',
    backgroundColor: 'color.background.neutral.subtle',
    borderRadius: "var(--ds-radius-small, 4px)",
    color: 'color.text.subtle',
    display: 'flex',
    font: 'font.body.small',
    gap: 'space.100',
    padding: 'space.050',
    whiteSpace: 'nowrap',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed'
    }
});
const $120e402a2d601a31$export$a2051cde2c49a6fb = (t0)=>{
    const $ = (0, $frIzR.c)(7);
    const { isExpanded: isExpanded, handleToggle: handleToggle } = t0;
    const intl = (0, $8C5kA.default)();
    const t1 = !isExpanded && $120e402a2d601a31$var$toggleButtonGradientStyles;
    let t2;
    if ($[0] !== handleToggle || $[1] !== intl || $[2] !== isExpanded) {
        t2 = !isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
            appearance: "subtle",
            spacing: "compact",
            icon: $120e402a2d601a31$var$_temp,
            label: intl.formatMessage($120e402a2d601a31$var$i18n.showAllApps),
            onClick: handleToggle,
            testId: "show-all-apps-button"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
            xcss: $120e402a2d601a31$var$buttonStyles,
            onClick: handleToggle,
            testId: "show-less-apps-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($laHi9))), {
            label: "",
            size: "small"
        }), intl.formatMessage($120e402a2d601a31$var$i18n.showLessApps));
        $[0] = handleToggle;
        $[1] = intl;
        $[2] = isExpanded;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== t1 || $[5] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: t1,
            testId: "single-line-byline-toggle-wrapper"
        }, t2);
        $[4] = t1;
        $[5] = t2;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
};
function $120e402a2d601a31$var$_temp(iconProps) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
        ...iconProps,
        size: "small"
    });
}


const $202654fe0d7532c2$var$singleLineBaseStyles = (0, $ecnYn.xcss)({
    whiteSpace: 'nowrap',
    width: '100%',
    overflowX: 'hidden'
});
const $202654fe0d7532c2$var$appsContainerStyles = (0, $ecnYn.xcss)({
    alignItems: 'center',
    gap: 'space.050',
    overflow: 'hidden'
});
const $202654fe0d7532c2$var$singleLineWrapStyles = (0, $ecnYn.xcss)({
    flexWrap: 'wrap',
    overflowX: 'visible'
});
const $202654fe0d7532c2$var$centerAlignmentStyles = (0, $ecnYn.xcss)({
    justifyContent: 'center',
    marginLeft: 'auto',
    marginRight: 'auto',
    width: 'initial'
});
const $202654fe0d7532c2$var$maxWidthStyles = (0, $ecnYn.xcss)({
    maxWidth: '760px'
});
// when the last byline app is on the first row of the byline, its top position should be within this offset
// this is assuming no byline items are wrapping themselves (which they shouldn't be)
const $202654fe0d7532c2$var$BYLINE_SINGLE_ROW_TOP_OFFSET = 15;
const $202654fe0d7532c2$var$AppsContainer = (t0)=>{
    const $ = (0, $frIzR.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
            xcss: $202654fe0d7532c2$var$appsContainerStyles
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
};
const $202654fe0d7532c2$export$cc95b64079434472 = /*#__PURE__*/ (0, $42omo.memo)((t0)=>{
    const $ = (0, $frIzR.c)(30);
    const { contentId: contentId, children: children, contentType: t1, isTitleCenterAlignedOverride: isTitleCenterAlignedOverride, showByLineExtensions: t2 } = t0;
    const contentType = t1 === undefined ? "page" : t1;
    const showByLineExtensions = t2 === undefined ? true : t2;
    const [shouldShowToggleButton, setShouldShowToggleButton] = (0, $42omo.useState)(false);
    const [haveAppsLoaded, setHaveAppsLoaded] = (0, $42omo.useState)(false);
    const [isExpanded, setIsExpanded] = (0, $42omo.useState)(true);
    const [currentParentWidth, setCurrentParentWidth] = (0, $42omo.useState)();
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $6S5EB.isExternalShareRequest)();
        $[0] = t3;
    } else t3 = $[0];
    const isExternalShare = t3;
    const bylineRef = (0, $42omo.useRef)(null);
    let t4;
    if ($[1] !== contentId || $[2] !== contentType) {
        t4 = {
            contentId: contentId,
            contentType: contentType
        };
        $[1] = contentId;
        $[2] = contentType;
        $[3] = t4;
    } else t4 = $[3];
    const { isTitleCenteredInitial: isTitleCenteredInitial } = (0, $aV3a0.useTitleContentPropertiesForEditor)(t4);
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const { hasApps: hasApps, connectItems: connectItems, forgeItems: forgeItems, forgeError: forgeError, loadingConnectItems: loadingConnectItems, loadingForgeItems: loadingForgeItems } = (0, $e105dde0a43b3be2$export$b613c53a0aeac846)(contentId);
    let t5;
    if ($[4] !== haveAppsLoaded || $[5] !== isExpanded) {
        t5 = ()=>{
            if (!bylineRef.current || !haveAppsLoaded) return;
            const forgeApps = Array.from(bylineRef.current.querySelectorAll("[data-testid=\"forge-byline-header-wrapper\"]"));
            const webItemApps = Array.from(bylineRef.current.querySelectorAll("[data-testid=\"web-item-link\"]"));
            const appsList = [
                ...webItemApps,
                ...forgeApps
            ];
            const lastAppElement = appsList[appsList.length - 1];
            if (!lastAppElement) return;
            const bylineRefRect = bylineRef.current?.getBoundingClientRect();
            const lastAppRect = lastAppElement.getBoundingClientRect();
            const areOnSameLine = Math.abs(bylineRefRect.top - lastAppRect.top) < $202654fe0d7532c2$var$BYLINE_SINGLE_ROW_TOP_OFFSET;
            if (isExpanded) {
                setShouldShowToggleButton(!areOnSameLine);
                return;
            }
            setShouldShowToggleButton(lastAppRect.right > bylineRefRect.right);
        };
        $[4] = haveAppsLoaded;
        $[5] = isExpanded;
        $[6] = t5;
    } else t5 = $[6];
    let t6;
    if ($[7] !== currentParentWidth || $[8] !== haveAppsLoaded || $[9] !== isExpanded) {
        t6 = [
            currentParentWidth,
            haveAppsLoaded,
            isExpanded
        ];
        $[7] = currentParentWidth;
        $[8] = haveAppsLoaded;
        $[9] = isExpanded;
        $[10] = t6;
    } else t6 = $[10];
    (0, $42omo.useEffect)(t5, t6);
    let t7;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = ()=>{
            setIsExpanded($202654fe0d7532c2$var$_temp);
        };
        $[11] = t7;
    } else t7 = $[11];
    const toggleShowAllApps = t7;
    let t8;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = ()=>{
            setHaveAppsLoaded(true);
        };
        $[12] = t8;
    } else t8 = $[12];
    const handleBylineAppsLoaded = t8;
    let t9;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = (0, (/*@__PURE__*/$parcel$interopDefault($8Yfbq)))((width)=>{
            setCurrentParentWidth(width);
        }, 100);
        $[13] = t9;
    } else t9 = $[13];
    const updateContentAreaWidth = t9;
    const RestrictAppsInOverflowContainer = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment : $202654fe0d7532c2$var$AppsContainer;
    const shouldShowApps = !isExternalShare && hasApps && showByLineExtensions;
    let t10;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = [
            (0, $gektR.AlignmentButtonContainer)
        ];
        $[14] = t10;
    } else t10 = $[14];
    let t11;
    if ($[15] !== RestrictAppsInOverflowContainer || $[16] !== children || $[17] !== connectItems || $[18] !== contentId || $[19] !== forgeError || $[20] !== forgeItems || $[21] !== isExpanded || $[22] !== isTitleCenterAlignedOverride || $[23] !== isTitleCenteredInitial || $[24] !== loadingConnectItems || $[25] !== loadingForgeItems || $[26] !== renderServerPlaceholder || $[27] !== shouldShowApps || $[28] !== shouldShowToggleButton) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
            to: t10
        }, (alignmentButtonContainer)=>{
            const isTitleCenterAligned = isTitleCenterAlignedOverride || (!alignmentButtonContainer.state.isLoadingComplete ? isTitleCenteredInitial : alignmentButtonContainer.state.alignmentButtonState === (0, $jVylI.TitleAlignmentType).CENTER);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $35Exc.BylineStyledMainDivSingleLine), {
                isExpanded: isExpanded
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
                alignItems: "center",
                testId: "byline-single-line",
                ref: bylineRef,
                xcss: [
                    $202654fe0d7532c2$var$singleLineBaseStyles,
                    (isExpanded || !shouldShowApps) && $202654fe0d7532c2$var$singleLineWrapStyles,
                    isTitleCenterAligned && $202654fe0d7532c2$var$centerAlignmentStyles,
                    isTitleCenterAligned && !isExpanded && $202654fe0d7532c2$var$maxWidthStyles
                ],
                gap: "space.050"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children, renderServerPlaceholder && window.__SSR_REACT_STREAMING__ ? null : shouldShowApps && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
                attribution: (0, $3IBnw.Attribution).ECOSYSTEM
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(RestrictAppsInOverflowContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $j2moL.LazyLivePagesByLineApps), {
                contentId: contentId,
                connectItems: connectItems,
                forgeItems: forgeItems,
                forgeError: forgeError,
                showLivePagesExtensionPoints: true,
                isSingleLineByline: true,
                onBylineAppsLoaded: handleBylineAppsLoaded,
                loadingConnectItems: loadingConnectItems,
                loadingForgeItems: loadingForgeItems,
                noContainer: true
            })))), renderServerPlaceholder && window.__SSR_REACT_STREAMING__ ? null : shouldShowApps && shouldShowToggleButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $120e402a2d601a31$export$a2051cde2c49a6fb), {
                isExpanded: isExpanded,
                handleToggle: toggleShowAllApps
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4JDbp.WidthObserver), {
                setWidth: updateContentAreaWidth
            }));
        });
        $[15] = RestrictAppsInOverflowContainer;
        $[16] = children;
        $[17] = connectItems;
        $[18] = contentId;
        $[19] = forgeError;
        $[20] = forgeItems;
        $[21] = isExpanded;
        $[22] = isTitleCenterAlignedOverride;
        $[23] = isTitleCenteredInitial;
        $[24] = loadingConnectItems;
        $[25] = loadingForgeItems;
        $[26] = renderServerPlaceholder;
        $[27] = shouldShowApps;
        $[28] = shouldShowToggleButton;
        $[29] = t11;
    } else t11 = $[29];
    return t11;
});
function $202654fe0d7532c2$var$_temp(currentState) {
    return !currentState;
}
module.exports["SingleLineByLine"] = $202654fe0d7532c2$export$cc95b64079434472;

});

parcelRegister("j2moL", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $irVI7 = parcelRequire("irVI7");


var $ln0hx = parcelRequire("ln0hx");

var $1eaCJ = parcelRequire("1eaCJ");


var $80koo = parcelRequire("80koo");


var $b3j2Y = parcelRequire("b3j2Y");


var $7Sm4c = parcelRequire("7Sm4c");


var $jmjWc = parcelRequire("jmjWc");





var $gMc0m = parcelRequire("gMc0m");





var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");

const $5ea8d19a294b60fd$var$containerStyles = null;
const $5ea8d19a294b60fd$var$hiddenStyles = (0, $ecnYn.xcss)({
    opacity: 0
});
const $5ea8d19a294b60fd$var$dynamicLineStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.skeleton',
    height: '12px',
    borderRadius: 'radius.small',
    display: 'inline-block',
    marginRight: 'space.250'
});
const $5ea8d19a294b60fd$var$forgeLineStyles = (0, $ecnYn.xcss)({
    width: '62px' // px taken from original placeholder
});
const $5ea8d19a294b60fd$var$placeholderWrapperStyles = (0, $ecnYn.xcss)({
    alignItems: 'center',
    display: 'flex',
    height: '24px'
});
const $5ea8d19a294b60fd$export$1196cbdc07fcbaba = (t0)=>{
    const $ = (0, $frIzR.c)(4);
    const { connectItems: connectItems, forgeItems: forgeItems, noContainer: t1 } = t0;
    const noContainer = t1 === undefined ? false : t1;
    let t2;
    if ($[0] !== connectItems || $[1] !== forgeItems || $[2] !== noContainer) {
        t2 = noContainer ? [
            ...connectItems,
            ...forgeItems
        ].map($5ea8d19a294b60fd$var$_temp) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-testid": "live-pages-byline-apps-loading",
            className: (0, $gMc0m.default)([
                "_1e0c116y"
            ])
        }, [
            ...connectItems,
            ...forgeItems
        ].map($5ea8d19a294b60fd$var$_temp2));
        $[0] = connectItems;
        $[1] = forgeItems;
        $[2] = noContainer;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
};
function $5ea8d19a294b60fd$var$_temp(item, index) {
    const isForgeItem = !!item?.properties?.title;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        testId: "live-pages-byline-app-placeholder",
        key: index,
        xcss: $5ea8d19a294b60fd$var$placeholderWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: isForgeItem ? [
            $5ea8d19a294b60fd$var$dynamicLineStyles,
            $5ea8d19a294b60fd$var$forgeLineStyles
        ] : $5ea8d19a294b60fd$var$dynamicLineStyles,
        testId: isForgeItem ? "forge-placeholder" : "connect-placeholder"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $5ea8d19a294b60fd$var$hiddenStyles
    }, item?.label)));
}
function $5ea8d19a294b60fd$var$_temp2(item_0, index_0) {
    const isForgeItem_0 = !!item_0?.properties?.title;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: isForgeItem_0 ? [
            $5ea8d19a294b60fd$var$dynamicLineStyles,
            $5ea8d19a294b60fd$var$forgeLineStyles
        ] : $5ea8d19a294b60fd$var$dynamicLineStyles,
        key: index_0,
        testId: isForgeItem_0 ? "forge-placeholder" : "connect-placeholder"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $5ea8d19a294b60fd$var$hiddenStyles
    }, item_0?.label));
}



var $aE48M = parcelRequire("aE48M");

const $dc19d0558ac0af95$export$da423a9f3d95b9b8 = (t0)=>{
    const $ = (0, $frIzR.c)(20);
    const { contentId: contentId, connectItems: connectItems, forgeItems: forgeItems, forgeError: forgeError, isSingleLineByline: isSingleLineByline, onBylineAppsLoaded: onBylineAppsLoaded, showLivePagesExtensionPoints: showLivePagesExtensionPoints, loadingConnectItems: t1, loadingForgeItems: t2, noContainer: t3 } = t0;
    const loadingConnectItems = t1 === undefined ? false : t1;
    const loadingForgeItems = t2 === undefined ? false : t2;
    const noContainer = t3 === undefined ? false : t3;
    const [showLoader, setShowLoader] = (0, $42omo.useState)(loadingConnectItems || loadingForgeItems);
    let t4;
    if ($[0] !== onBylineAppsLoaded) {
        t4 = ()=>{
            setShowLoader(false);
            onBylineAppsLoaded?.();
        };
        $[0] = onBylineAppsLoaded;
        $[1] = t4;
    } else t4 = $[1];
    const handleLoad = t4;
    let t5;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ln0hx.ExperienceStart), {
            name: (0, $irVI7.EXTENSION_POINT_BYLINE_EXPERIENCE)
        });
        $[2] = t5;
    } else t5 = $[2];
    let t6;
    if ($[3] !== connectItems || $[4] !== forgeItems || $[5] !== noContainer || $[6] !== showLoader) {
        t6 = showLoader && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5ea8d19a294b60fd$export$1196cbdc07fcbaba), {
            connectItems: connectItems,
            forgeItems: forgeItems,
            noContainer: noContainer
        });
        $[3] = connectItems;
        $[4] = forgeItems;
        $[5] = noContainer;
        $[6] = showLoader;
        $[7] = t6;
    } else t6 = $[7];
    let t7;
    if ($[8] !== connectItems || $[9] !== contentId || $[10] !== forgeError || $[11] !== forgeItems || $[12] !== handleLoad || $[13] !== isSingleLineByline || $[14] !== showLivePagesExtensionPoints || $[15] !== showLoader) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $80koo.RequireLegacyWRM), {
            key: "byline-app-wrm",
            wrm: "wr!com.atlassian.plugins.atlassian-connect-plugin:confluence-atlassian-connect-content-byline-resources-v5"
        }, ()=>{
            if (forgeError) {
                if (!(0, $7Sm4c.isErrorMarkedAsHandled)(forgeError)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
                    error: forgeError
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
                    name: (0, $irVI7.EXTENSION_POINT_BYLINE_EXPERIENCE)
                });
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aE48M.ByLineAppsComponent), {
                key: contentId,
                contentId: contentId,
                forgeItems: forgeItems,
                connectItems: connectItems,
                showLivePagesExtensionPoints: showLivePagesExtensionPoints,
                onLoad: handleLoad,
                showLoader: showLoader,
                isSingleLineByline: isSingleLineByline
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
                name: (0, $irVI7.EXTENSION_POINT_BYLINE_EXPERIENCE)
            }));
        });
        $[8] = connectItems;
        $[9] = contentId;
        $[10] = forgeError;
        $[11] = forgeItems;
        $[12] = handleLoad;
        $[13] = isSingleLineByline;
        $[14] = showLivePagesExtensionPoints;
        $[15] = showLoader;
        $[16] = t7;
    } else t7 = $[16];
    let t8;
    if ($[17] !== t6 || $[18] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, t5, t6, t7);
        $[17] = t6;
        $[18] = t7;
        $[19] = t8;
    } else t8 = $[19];
    return t8;
};

const $dc19d0558ac0af95$export$573ad1d5e82d9d7e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "9W4UB",
    name: "LazyLivePagesByLineApps",
    loader: async ()=>{
        return (await Promise.resolve(module.exports)).LivePagesByLineApps;
    },
    loading: (0, $5ea8d19a294b60fd$export$1196cbdc07fcbaba)
});
module.exports["LivePagesByLineApps"] = $dc19d0558ac0af95$export$da423a9f3d95b9b8;
module.exports["LazyLivePagesByLineApps"] = $dc19d0558ac0af95$export$573ad1d5e82d9d7e;

});

parcelRegister("aE48M", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $iRRvH = parcelRequire("iRRvH");


var $inPa6 = parcelRequire("inPa6");


var $9wGTI = parcelRequire("9wGTI");


var $asQED = parcelRequire("asQED");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");










var $7sObp = parcelRequire("7sObp");


var $eSUdr = parcelRequire("eSUdr");


var $j1Ss3 = parcelRequire("j1Ss3");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $lGgRw = parcelRequire("lGgRw");


var $2W0qg = parcelRequire("2W0qg");

var $ecnYn = parcelRequire("ecnYn");


var $3gadb = parcelRequire("3gadb");


var $9hlns = parcelRequire("9hlns");





var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");





var $6mKj3 = parcelRequire("6mKj3");


var $7Ndnw = parcelRequire("7Ndnw");


var $aF5bm = parcelRequire("aF5bm");


var $4vC63 = parcelRequire("4vC63");


var $7QUD1 = parcelRequire("7QUD1");


var $lOI2p = parcelRequire("lOI2p");


var $jYZsR = parcelRequire("jYZsR");


var $hIaUw = parcelRequire("hIaUw");


var $grspz = parcelRequire("grspz");


var $8a9Dm = parcelRequire("8a9Dm");


var $9fBoq = parcelRequire("9fBoq");


var $gKr8t = parcelRequire("gKr8t");


var $ep3mz = parcelRequire("ep3mz");


var $bQm3c = parcelRequire("bQm3c");


var $7W8i8 = parcelRequire("7W8i8");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $3jwuS = parcelRequire("3jwuS");


var $de2j9 = parcelRequire("de2j9");


var $6UqI3 = parcelRequire("6UqI3");


var $6uUjl = parcelRequire("6uUjl");


var $jMyy4 = parcelRequire("jMyy4");


var $1JyKZ = parcelRequire("1JyKZ");

var $70b51fb3412d0931$exports = {};
$70b51fb3412d0931$exports = new URL("AK_AddonIcon.7997ef8d.svg", import.meta.url).toString();



var $83fWZ = parcelRequire("83fWZ");

// Type for content property value structure
// Utility function to check if a value is a non-empty string
const $3b594b06ac9b7376$var$isNonEmptyString = (value)=>{
    return typeof value === 'string' && value.trim() !== '';
};
// Utility function to validate and set a byline content property value
const $3b594b06ac9b7376$var$validatePropertyValue = (key, value, validatedProperties)=>{
    if (value !== undefined) {
        if ($3b594b06ac9b7376$var$isNonEmptyString(value)) validatedProperties[key] = value;
        else // eslint-disable-next-line no-console
        console.warn(`Byline content property ${key} must be a non-empty string, got:`, typeof value);
    }
};
// Validation function for extracting property node from GraphQL query data
const $3b594b06ac9b7376$var$validateContentPropertyQuery = (data, contentPropertyKey)=>{
    // Check if data exists and has the expected structure
    if (!data || !data.content || !data.content.nodes || data.content.nodes.length === 0 || !data.content.nodes[0].properties || !data.content.nodes[0].properties.nodes || data.content.nodes[0].properties.nodes.length === 0) {
        // eslint-disable-next-line no-console
        console.warn('Invalid byline content property query data');
        return null;
    }
    // Get all objects that match the contentPropertyKey
    const properties = data.content.nodes[0].properties.nodes;
    const contentKeyPattern = new RegExp(contentPropertyKey);
    const matchingObjects = properties.filter((property)=>contentKeyPattern.test(property.key ?? ''));
    if (matchingObjects.length === 0) {
        // eslint-disable-next-line no-console
        console.warn('No property nodes matching content property key pattern found');
        return null;
    }
    if (matchingObjects.length > 1) {
        // eslint-disable-next-line no-console
        console.warn('Multiple property nodes matching content property key pattern found. Please make sure your contentPropertyKey is unique, like a UUID.');
        return null;
    }
    const propertyNode = matchingObjects[0];
    const validContentPropertyKey = propertyNode.key;
    if (!propertyNode.value) {
        // eslint-disable-next-line no-console
        console.warn('Byline content property data has no value');
        return null;
    }
    return {
        propertyNode: propertyNode,
        validContentPropertyKey: validContentPropertyKey
    };
};
// Common function to validate title, icon, and tooltip properties
const $3b594b06ac9b7376$var$validateProperties = (propertyValue, validatedProperties)=>{
    // validate each property
    $3b594b06ac9b7376$var$validatePropertyValue('title', propertyValue.title, validatedProperties);
    $3b594b06ac9b7376$var$validatePropertyValue('icon', propertyValue.icon, validatedProperties);
    $3b594b06ac9b7376$var$validatePropertyValue('tooltip', propertyValue.tooltip, validatedProperties);
};
const $3b594b06ac9b7376$export$48cf1be175912dd = (data, defaultValues)=>{
    try {
        // Validate and extract the query data
        const queryResult = $3b594b06ac9b7376$var$validateContentPropertyQuery(data, defaultValues.contentPropertyKey);
        if (!queryResult) return defaultValues;
        const { propertyNode: propertyNode, validContentPropertyKey: validContentPropertyKey } = queryResult;
        // Parse JSON with error handling
        let propertyValue;
        try {
            propertyValue = JSON.parse(propertyNode.value ?? '');
        } catch (jsonError) {
            // eslint-disable-next-line no-console
            console.error('Failed to parse byline content property JSON:', jsonError);
            return defaultValues;
        }
        // Validate the structure of the parsed value
        if (typeof propertyValue !== 'object' || propertyValue === null) {
            // eslint-disable-next-line no-console
            console.error('Byline content property value is not an object:', propertyValue);
            return defaultValues;
        }
        const validatedProperties = {
            ...defaultValues
        };
        // Validate each property using the byline content property value utility function
        $3b594b06ac9b7376$var$validateProperties(propertyValue, validatedProperties);
        if (validContentPropertyKey && validContentPropertyKey !== '') validatedProperties.contentPropertyKey = validContentPropertyKey;
        return validatedProperties;
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Unexpected error in content property validation:', error);
        return defaultValues;
    }
};
const $3b594b06ac9b7376$export$96933cae6933ce51 = (eventData, defaultValues)=>{
    try {
        // Check if eventData exists and has the expected structure
        if (!eventData || !eventData.propertyKey || !eventData.valueUpdate) {
            // eslint-disable-next-line no-console
            console.warn('Invalid FORGE_CONTENT_PROPERTY_UPDATED event data structure');
            return defaultValues;
        }
        const valueUpdate = eventData.valueUpdate;
        // Validate the structure of valueUpdate
        if (typeof valueUpdate !== 'object' || valueUpdate === null) {
            // eslint-disable-next-line no-console
            console.error('Event valueUpdate is not an object:', valueUpdate);
            return defaultValues;
        }
        const validatedProperties = {
            ...defaultValues
        };
        $3b594b06ac9b7376$var$validateProperties(valueUpdate, validatedProperties);
        return validatedProperties;
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Unexpected error in event data validation:', error);
        return defaultValues;
    }
};


const $1cb9b1bda2de2c04$var$EXPERIENCE_NAME = (0, $irVI7.VIEW_PAGE_BYLINE_FORGE_EXPERIENCE); // General content property query for reading all content properties
// eslint-disable-next-line graphql-relay-compat/consistent-graphql-operation-naming
const $1cb9b1bda2de2c04$var$GENERAL_CONTENT_PROPERTY_QUERY = (0, $eSUdr.default)`query GeneralContentPropertyQuery($contentId:ID!){content(id:$contentId){nodes{id properties{nodes{id key version{number}value}}}}}`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1cb9b1bda2de2c04$var$ContentWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1yt4v47k _p12fdgin _c71ldgin _18m91wug",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $1cb9b1bda2de2c04$var$i18n = (0, $cgtv4.defineMessages)({
    appIcon: {
        id: "content-header.forge.byline-app.app-icon-alt",
        defaultMessage: "App Icon"
    }
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1cb9b1bda2de2c04$var$ByLineForgeAppHeaderWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(8);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "span" : t2;
        const { isHidden: isHidden, ...__cmpldp } = __cmplp;
        const t3 = __cmplp.isHidden ? "none" : "inline-block";
        let t4;
        if ($[3] !== t3) {
            t4 = (0, $7sObp.default)(t3);
            $[3] = t3;
            $[4] = t4;
        } else t4 = $[4];
        let t5;
        if ($[5] !== __cmpls || $[6] !== t4) {
            t5 = {
                ...__cmpls,
                "--_z2o4qt": t4
            };
            $[5] = __cmpls;
            $[6] = t4;
            $[7] = t5;
        } else t5 = $[7];
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
            ...__cmpldp,
            style: t5,
            ref: __cmplr,
            className: (0, $gMc0m.default)([
                "_1e0c188t _2hwxze3t _9oik1r31 _1bnxglyw _jf4cnqa1 _8kwo1r31 _1vwxglyw _2gcsnqa1 _d0altlke",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
const $1cb9b1bda2de2c04$var$Image = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "img" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1yt4m31d _4t3idlk8 _1bsbdlk8 _1e0c1o8l _s7n41ndm _syaz1q3r",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $1cb9b1bda2de2c04$var$forgeAppButtonStyles = (0, $ecnYn.xcss)({
    alignItems: 'center',
    backgroundColor: 'color.background.neutral.subtle',
    borderRadius: 'radius.small',
    display: 'inline-flex',
    font: 'font.body.small',
    color: 'color.text.subtle',
    gap: 'space.050',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '16px',
    marginRight: 'space.0',
    padding: 'space.050',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered',
        textDecoration: 'none'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed'
    }
});
const $1cb9b1bda2de2c04$var$forgeAppButtonDotStyles = (0, $ecnYn.xcss)({
    '::before': {
        content: '"\u2022"',
        display: 'inline-block',
        paddingRight: 'space.050',
        alignSelf: 'center',
        textDecoration: 'none'
    }
});
const $1cb9b1bda2de2c04$var$ByLineForgeAppTrigger = ({ app: app, reference: reference, defineTriggerRef: defineTriggerRef, toggleClose: toggleClose, isOpen: isOpen, extensionData: extensionData, isHidden: isHidden, hideDot: hideDot, appTitle: appTitle, setAppTitle: setAppTitle })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const appHasDynamicProperties = !!app.properties.dynamicProperties;
    const [contentPropertyKey, setContentPropertyKey] = (0, $42omo.useState)(app.properties.contentPropertyKey || '');
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const workspaceARI = (0, $aF5bm.useWorkspaceARI)();
    const [appIcon, setAppIcon] = (0, $42omo.useState)(app.properties.icon || null);
    const [appTooltip, setAppTooltip] = (0, $42omo.useState)(app.properties.tooltip || null);
    const [isLoading, setIsLoading] = (0, $42omo.useState)(appHasDynamicProperties);
    const localId = (0, $42omo.useMemo)(()=>(0, $grspz.getLocalId)(app.id), [
        app.id
    ]);
    const getContextToken = (0, $1JyKZ.useGetContextToken)({
        extension: app,
        extensionData: extensionData,
        localId: localId,
        contextIds: [
            workspaceARI
        ]
    });
    const getContextTokenRef = (0, $42omo.useRef)(getContextToken);
    (0, $42omo.useEffect)(()=>{
        getContextTokenRef.current = getContextToken;
    }, [
        getContextToken
    ]);
    const [bylineDynamicPropertiesMutation] = (0, $j1Ss3.useMutation)((0, $eSUdr.default)`mutation ByLineForgeAppinvokeExtensionMutation($input:InvokeExtensionInput!){invokeExtension(input:$input){success response{body}errors{message extensions{statusCode}}}}`, {
        client: (0, $gKr8t.getAGGClient)()
    });
    const fetchDynamicProperties = (0, $42omo.useCallback)(async ()=>{
        const extensionId = app.id;
        const contextPayload = {
            cloudId: cloudId,
            localId: localId,
            extension: extensionData
        };
        let contextToken;
        if ((0, $6mKj3.expVal)('forge_context_token_byline_app', 'isEnabled', false)) try {
            contextToken = await getContextTokenRef.current();
        } catch (e) {
            throw new Error(`Failed to get context token: ${e}`);
        }
        const result = await bylineDynamicPropertiesMutation({
            variables: {
                input: {
                    entryPoint: 'dynamicProperties',
                    contextIds: [
                        workspaceARI
                    ],
                    extensionId: extensionId,
                    payload: {
                        context: contextPayload,
                        ...contextPayload,
                        // TODO: This is temporary for Forge apps' backward compatibility
                        ...contextToken ? {
                            contextToken: contextToken
                        } : {}
                    }
                }
            }
        }).catch((e)=>{
            return {
                data: {
                    invokeExtension: {
                        success: false,
                        errors: [
                            {
                                message: e
                            }
                        ]
                    }
                }
            };
        });
        setIsLoading(false); // @ts-expect-error The types here are a bit messy. Typegen for AGG should help solve that
        const { response: response, success: success } = result.data?.invokeExtension; // @ts-expect-error The types here are a bit messy. Typegen for AGG should help solve that
        const errors = result.data?.invokeExtension.errors;
        if (!success) {
            const logger = (0, $7W8i8.getLogger)('by-line-apps');
            const errorMessages = errors.map((error)=>error.message).join(' '); // prints error to aid forge developer && allow Ecosystem to track these errors
            logger.error`Failed to fetch dynamic properties for ByLine Forge app: ${app.id} with error: ${errorMessages}`;
            if (errorMessages !== 'User consent required') (0, $5ZqQS.getMonitoringClient)().submitError(new Error(`Failed to fetch dynamic properties for ByLine Forge app: ${app.id} with error: ${errorMessages}`), {
                attribution: (0, $3IBnw.Attribution).ECOSYSTEM
            });
            return;
        }
        if (response.body) {
            const { body: { title: dynamicPropsTitle, tooltip: dynamicPropsTooltip, icon: dynamicPropsIcon } } = response;
            dynamicPropsTitle && setAppTitle((0, $9fBoq.extensionTitle)(app, dynamicPropsTitle));
            dynamicPropsTooltip && setAppTooltip(dynamicPropsTooltip);
            dynamicPropsIcon && setAppIcon(dynamicPropsIcon);
        }
    }, [
        app,
        cloudId,
        extensionData,
        bylineDynamicPropertiesMutation,
        workspaceARI,
        setAppTitle,
        localId
    ]);
    // Validation function for content property data
    const validateContentPropertyDataCallback = (0, $42omo.useCallback)((data)=>{
        const defaultValues = {
            title: appTitle,
            icon: app.properties.icon || '',
            tooltip: app.properties.tooltip || '',
            contentPropertyKey: app.properties.contentPropertyKey || ''
        };
        return (0, $3b594b06ac9b7376$export$48cf1be175912dd)(data, defaultValues);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []); // Validation function specifically for FORGE_CONTENT_PROPERTY_UPDATED event data
    const validateEventDataCallback = (0, $42omo.useCallback)((eventData)=>{
        const defaultValues = {
            title: appTitle,
            icon: app.properties.icon || '',
            tooltip: app.properties.tooltip || ''
        };
        return (0, $3b594b06ac9b7376$export$96933cae6933ce51)(eventData, defaultValues);
    }, [
        appTitle,
        app.properties.icon,
        app.properties.tooltip
    ]);
    const runGeneralContentPropertyQuery = (0, $42omo.useCallback)(()=>{
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { data: generalContentPropertyData, refetch: refetchQueryContentProperties } = /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $jMyy4.useQueryInterop)($1cb9b1bda2de2c04$var$GENERAL_CONTENT_PROPERTY_QUERY, {
            variables: {
                contentId: extensionData.content?.id
            }
        });
        return {
            data: generalContentPropertyData,
            refetch: refetchQueryContentProperties
        };
    }, [
        extensionData
    ]); // Run general content property query to get all properties (including IDs), if the app has a contentPropertyKey
    const queryResult = app.properties.contentPropertyKey ? runGeneralContentPropertyQuery() : null;
    const generalData = queryResult?.data || null;
    const refetchContentProperties = queryResult?.refetch; // Validate content property data and get clean values
    const validatedProperties = validateContentPropertyDataCallback(generalData);
    (0, $42omo.useEffect)(()=>{
        // refetch for updates on popup.content close
        // Only run if app has defined contentPropertyKey
        if (contentPropertyKey && !!validatedProperties.contentPropertyKey && validatedProperties.contentPropertyKey !== '') {
            setContentPropertyKey(validatedProperties.contentPropertyKey);
            setIsLoading(false); // Update app properties with validated values
            if (validatedProperties.title && validatedProperties.title !== '') setAppTitle((0, $9fBoq.extensionTitle)(app, validatedProperties.title));
            if (validatedProperties.icon && validatedProperties.icon !== '') setAppIcon(validatedProperties.icon);
            if (validatedProperties.tooltip && validatedProperties.tooltip !== '') setAppTooltip(validatedProperties.tooltip);
        } else if (!isOpen && appHasDynamicProperties) fetchDynamicProperties();
    }, [
        isOpen,
        appHasDynamicProperties,
        fetchDynamicProperties,
        validatedProperties.title,
        validatedProperties.icon,
        validatedProperties.tooltip,
        validatedProperties.contentPropertyKey,
        setAppTitle,
        setAppIcon,
        setAppTooltip,
        setContentPropertyKey,
        contentPropertyKey,
        app
    ]); // Event listener for FORGE_CONTENT_PROPERTY_UPDATED events
    (0, $42omo.useEffect)(()=>{
        const handleContentPropertyUpdate = async (event)=>{
            if (event.detail?.payload?.propertyKey !== app.properties.contentPropertyKey) return;
             // Refetch content properties to get the latest data and ensure proper validation
            // This is important when multiple apps use the same contentPropertyKey
            if (refetchContentProperties) try {
                await refetchContentProperties();
            } catch (error) {
                // eslint-disable-next-line no-console
                console.warn('Failed to refetch content properties on event update:', error);
            }
             // Validate the event data using the specific event validation method
            const validatedData = validateEventDataCallback(event.detail?.payload); // Update app properties with validated values
            if (validatedData.title && validatedData.title !== '') setAppTitle((0, $9fBoq.extensionTitle)(app, validatedData.title));
            if (validatedData.icon && validatedData.icon !== '') setAppIcon(validatedData.icon);
            if (validatedData.tooltip && validatedData.tooltip !== '') setAppTooltip(validatedData.tooltip);
        }; // Only process if this event is for our content property key
        if (!contentPropertyKey || contentPropertyKey === '') return ()=>{}; // Return empty cleanup function to maintain React lifecycle consistency
         // Add event listener
        // @ts-ignore - typescript error since this is a custom event
        document.addEventListener('forge.bridge.FORGE_CONTENT_PROPERTY_UPDATED', handleContentPropertyUpdate); // Cleanup function to remove event listener
        return ()=>{
            // @ts-ignore - typescript error since this is a custom event
            document.removeEventListener('forge.bridge.FORGE_CONTENT_PROPERTY_UPDATED', handleContentPropertyUpdate);
        };
    }, [
        validateEventDataCallback,
        contentPropertyKey,
        setAppTitle,
        setAppIcon,
        setAppTooltip,
        app,
        refetchContentProperties
    ]);
    const ForgeAppButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
        testId: "byline-forge-app-button",
        xcss: [
            $1cb9b1bda2de2c04$var$forgeAppButtonStyles,
            !(isHidden || hideDot) && $1cb9b1bda2de2c04$var$forgeAppButtonDotStyles
        ]
    }, appIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1cb9b1bda2de2c04$var$Image, {
        "data-testid": "byline-forge-app-image",
        src: appIcon,
        onError: (e)=>{
            e.currentTarget.src = (0, (/*@__PURE__*/$parcel$interopDefault($70b51fb3412d0931$exports)));
        },
        alt: formatMessage($1cb9b1bda2de2c04$var$i18n.appIcon)
    }), appTitle);
    const bylineForgeAppHeaderWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1cb9b1bda2de2c04$var$ByLineForgeAppHeaderWrapper, {
        ref: defineTriggerRef && reference ? defineTriggerRef(reference) : null,
        onClick: toggleClose,
        isHidden: isHidden,
        "data-testid": "forge-byline-header-wrapper"
    }, isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
        size: "small",
        testId: "byline-forge-app-trigger-loading-spinner"
    }) : ForgeAppButton);
    return app.properties?.keyboardShortcut?.accelerator ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4vC63.ForgeKeyboardShortcutVisualizer), {
        module: app,
        tooltip: appTooltip ?? ''
    }, bylineForgeAppHeaderWrapper) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        tag: "span",
        content: appTooltip
    }, bylineForgeAppHeaderWrapper);
};
const $1cb9b1bda2de2c04$export$d2159b9f3f077903 = (t0)=>{
    const $ = (0, $frIzR.c)(78);
    const { app: app, contentId: contentId, isHidden: t1, setShowAll: t2, hideDot: t3 } = t0;
    const isHidden = t1 === undefined ? false : t1;
    const setShowAll = t2 === undefined ? $1cb9b1bda2de2c04$var$_temp : t2;
    const hideDot = t3 === undefined ? false : t3;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { activationId: activationId } = (0, $bQm3c.useSessionData)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const isEditing = isLivePage || isOnEditRoute;
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const [popupRef, setPopupRef] = (0, $42omo.useState)(null);
    const [triggerRef, setTriggerRef] = (0, $42omo.useState)(null);
    let t4;
    if ($[0] !== app) {
        t4 = (0, $9fBoq.extensionTitle)(app);
        $[0] = app;
        $[1] = t4;
    } else t4 = $[1];
    const [appTitle, setAppTitle] = (0, $42omo.useState)(t4);
    const [t5] = (0, $ep3mz.usePageState)();
    const { routeName: routeName, spaceKey: spaceAlias } = t5;
    const { spaceId: spaceId, spaceKey: spaceKey } = (0, $6uUjl.useSpaceIdentifiers)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t6;
    if ($[2] !== routeName) {
        t6 = (0, $hIaUw.getContentType)(routeName);
        $[2] = routeName;
        $[3] = t6;
    } else t6 = $[3];
    const t7 = isLivePage ? "live" : null;
    let t8;
    if ($[4] !== contentId || $[5] !== t6 || $[6] !== t7) {
        t8 = {
            id: contentId,
            type: t6,
            subtype: t7
        };
        $[4] = contentId;
        $[5] = t6;
        $[6] = t7;
        $[7] = t8;
    } else t8 = $[7];
    const t9 = spaceKey || spaceAlias;
    let t10;
    if ($[8] !== spaceId || $[9] !== t9) {
        t10 = {
            id: spaceId,
            key: t9
        };
        $[8] = spaceId;
        $[9] = t9;
        $[10] = t10;
    } else t10 = $[10];
    let t11;
    if ($[11] !== t10 || $[12] !== t8) {
        t11 = {
            type: (0, $7Ndnw.FORGE_MODULE_BYLINE),
            content: t8,
            space: t10
        };
        $[11] = t10;
        $[12] = t8;
        $[13] = t11;
    } else t11 = $[13];
    const extensionData = (0, $83fWZ.useMemoizedObj)(t11);
    let t12;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = (node)=>{
            setPopupRef(node);
        };
        $[14] = t12;
    } else t12 = $[14];
    const defineContentRef = t12;
    let t13;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t13 = (ref)=>(node_0)=>{
                setTriggerRef(node_0);
                ref(node_0);
            };
        $[15] = t13;
    } else t13 = $[15];
    const defineTriggerRef = t13;
    let t14;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = ()=>{
            setIsOpen(false);
        };
        $[16] = t14;
    } else t14 = $[16];
    const onClose = t14;
    let t15;
    if ($[17] !== contentId || $[18] !== experienceTracker || $[19] !== isOpen) {
        t15 = ()=>{
            !isOpen && experienceTracker.start({
                name: $1cb9b1bda2de2c04$var$EXPERIENCE_NAME,
                id: contentId,
                timeout: 10000
            });
            setIsOpen(!isOpen);
        };
        $[17] = contentId;
        $[18] = experienceTracker;
        $[19] = isOpen;
        $[20] = t15;
    } else t15 = $[20];
    const toggleClose = t15;
    let t16;
    if ($[21] !== activationId || $[22] !== app || $[23] !== contentId || $[24] !== createAnalyticsEvent || $[25] !== experienceTracker || $[26] !== routeName || $[27] !== spaceAlias || $[28] !== spaceId) {
        t16 = ()=>{
            experienceTracker.succeed({
                name: $1cb9b1bda2de2c04$var$EXPERIENCE_NAME
            });
            const appId = (0, $8a9Dm.getAppId)(app);
            createAnalyticsEvent({
                type: "sendTrackEvent",
                data: {
                    action: "invoked",
                    actionSubject: "forgeExtension",
                    actionSubjectId: appId,
                    containerType: "space",
                    containerId: spaceId,
                    objectType: (0, $hIaUw.getContentType)(routeName),
                    objectId: contentId,
                    source: (0, $7Ndnw.FORGE_MODULE_BYLINE),
                    attributes: {
                        activationId: activationId,
                        appId: appId,
                        moduleType: (0, $7Ndnw.FORGE_MODULE_BYLINE),
                        moduleKey: (0, $8a9Dm.getModuleKey)(app),
                        spaceType: (0, $6UqI3.getSpaceType)(spaceAlias),
                        spaceId: spaceId
                    }
                }
            }).fire();
        };
        $[21] = activationId;
        $[22] = app;
        $[23] = contentId;
        $[24] = createAnalyticsEvent;
        $[25] = experienceTracker;
        $[26] = routeName;
        $[27] = spaceAlias;
        $[28] = spaceId;
        $[29] = t16;
    } else t16 = $[29];
    const onInitialRender = t16;
    let t17;
    if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
        t17 = {
            onClose: onClose,
            close: onClose
        };
        $[30] = t17;
    } else t17 = $[30];
    const bridge = t17;
    let t18;
    if ($[31] !== popupRef || $[32] !== triggerRef) {
        t18 = {
            onClose: onClose,
            popupRef: popupRef,
            triggerRef: triggerRef
        };
        $[31] = popupRef;
        $[32] = triggerRef;
        $[33] = t18;
    } else t18 = $[33];
    (0, $lOI2p.useInlineDialogCloseManager)(t18);
    if (!spaceKey) return null;
    let InvisibleDiv;
    if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
        InvisibleDiv = /*#__PURE__*/ (0, $42omo.forwardRef)($1cb9b1bda2de2c04$var$_temp2);
        $[34] = InvisibleDiv;
    } else InvisibleDiv = $[34];
    if (app.properties.viewportContainer === "modal" && (0, $9wGTI.fg)("platform_add_modal_support_to_bylineitem_extension")) {
        let t19;
        if ($[35] !== app || $[36] !== appTitle || $[37] !== extensionData || $[38] !== hideDot || $[39] !== isHidden || $[40] !== isOpen || $[41] !== toggleClose) {
            t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1cb9b1bda2de2c04$var$ByLineForgeAppTrigger, {
                app: app,
                appTitle: appTitle,
                setAppTitle: setAppTitle,
                isOpen: isOpen,
                toggleClose: toggleClose,
                extensionData: extensionData,
                isHidden: isHidden,
                hideDot: hideDot
            });
            $[35] = app;
            $[36] = appTitle;
            $[37] = extensionData;
            $[38] = hideDot;
            $[39] = isHidden;
            $[40] = isOpen;
            $[41] = toggleClose;
            $[42] = t19;
        } else t19 = $[42];
        let t20;
        if ($[43] !== InvisibleDiv || $[44] !== app || $[45] !== extensionData || $[46] !== isOpen || $[47] !== onInitialRender) {
            t20 = isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(InvisibleDiv, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7QUD1.ByLineForgeApp), {
                app: app,
                extensionData: extensionData,
                onInitialRender: onInitialRender,
                onTearDown: onClose,
                bridge: bridge
            })) : null;
            $[43] = InvisibleDiv;
            $[44] = app;
            $[45] = extensionData;
            $[46] = isOpen;
            $[47] = onInitialRender;
            $[48] = t20;
        } else t20 = $[48];
        let t21;
        if ($[49] !== t19 || $[50] !== t20) {
            t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t19, t20);
            $[49] = t19;
            $[50] = t20;
            $[51] = t21;
        } else t21 = $[51];
        return t21;
    }
    const t19 = !isEditing;
    let t20;
    if ($[52] !== app || $[53] !== extensionData || $[54] !== onInitialRender || $[55] !== popupRef) {
        t20 = (t21)=>{
            const { update: scheduleUpdate } = t21;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1cb9b1bda2de2c04$var$ContentWrapper, {
                ref: defineContentRef,
                "data-testid": "forge-popup-content-wrapper"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jYZsR.ResizeChangeListener), {
                onUpdate: scheduleUpdate,
                popupRef: popupRef
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7QUD1.ByLineForgeApp), {
                app: app,
                extensionData: extensionData,
                onInitialRender: onInitialRender,
                onTearDown: onClose,
                bridge: bridge
            })));
        };
        $[52] = app;
        $[53] = extensionData;
        $[54] = onInitialRender;
        $[55] = popupRef;
        $[56] = t20;
    } else t20 = $[56];
    let t21;
    if ($[57] !== app || $[58] !== appTitle || $[59] !== extensionData || $[60] !== hideDot || $[61] !== isHidden || $[62] !== isOpen || $[63] !== toggleClose) {
        t21 = (t22)=>{
            const { ref: ref_0 } = t22;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1cb9b1bda2de2c04$var$ByLineForgeAppTrigger, {
                app: app,
                appTitle: appTitle,
                setAppTitle: setAppTitle,
                reference: ref_0,
                isOpen: isOpen,
                defineTriggerRef: defineTriggerRef,
                toggleClose: toggleClose,
                extensionData: extensionData,
                isHidden: isHidden,
                hideDot: hideDot
            });
        };
        $[57] = app;
        $[58] = appTitle;
        $[59] = extensionData;
        $[60] = hideDot;
        $[61] = isHidden;
        $[62] = isOpen;
        $[63] = toggleClose;
        $[64] = t21;
    } else t21 = $[64];
    let t22;
    if ($[65] !== appTitle || $[66] !== isOpen || $[67] !== t19 || $[68] !== t20 || $[69] !== t21) {
        t22 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
            shouldRenderToParent: t19,
            testId: "forge-action-popup",
            role: "dialog",
            content: t20,
            label: appTitle,
            isOpen: isOpen,
            placement: "bottom-start",
            trigger: t21
        });
        $[65] = appTitle;
        $[66] = isOpen;
        $[67] = t19;
        $[68] = t20;
        $[69] = t21;
        $[70] = t22;
    } else t22 = $[70];
    let t23;
    if ($[71] !== app || $[72] !== isEditing || $[73] !== setShowAll) {
        t23 = !isEditing && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4vC63.ForgeKeyboardShortcut), {
            module: app,
            action: ()=>{
                setShowAll(true);
                setIsOpen(true);
            }
        });
        $[71] = app;
        $[72] = isEditing;
        $[73] = setShowAll;
        $[74] = t23;
    } else t23 = $[74];
    let t24;
    if ($[75] !== t22 || $[76] !== t23) {
        t24 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t22, t23);
        $[75] = t22;
        $[76] = t23;
        $[77] = t24;
    } else t24 = $[77];
    return t24;
};
function $1cb9b1bda2de2c04$var$_temp() {}
function $1cb9b1bda2de2c04$var$_temp2(t0, __cmplr) {
    const { as: t1, style: __cmpls, ...__cmplp } = t0;
    const C = t1 === undefined ? "div" : t1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0cglyw",
            __cmplp.className
        ])
    });
}

















var $4KS7f = parcelRequire("4KS7f");


var $tvI67 = parcelRequire("tvI67");

const $8a60fc49afcf0f5b$var$i18n = (0, $cgtv4.defineMessages)({
    showMore: {
        id: "content-header.by-line.apps-show-more",
        defaultMessage: "Show more"
    },
    showLess: {
        id: "content-header.by-line.apps.show-less",
        defaultMessage: "Show less"
    }
});
const $8a60fc49afcf0f5b$export$94132a0e348806d4 = null;
// eslint-disable-next-line @compiled/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/design-system/no-styled-tagged-template-expression -- Ignored via go/DSP-18766
const $8a60fc49afcf0f5b$var$ShowMoreLess = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1o8l _syazazsu _80omtlke _1n6q1c8u _tw171r31 _135cglyw _1p5wnqa1 _1kt91mp2 _cfu11o8l _is06azsu",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); /* eslint-disable @atlaskit/ui-styling-standard/no-important-styles */ 
const $8a60fc49afcf0f5b$var$StyledButton = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? (0, $4KS7f.default) : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1w90d34b _12r21hhk",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); /* eslint-enable @atlaskit/ui-styling-standard/no-important-styles */ 
const $8a60fc49afcf0f5b$export$e5bc424bebb08325 = (t0)=>{
    const $ = (0, $frIzR.c)(11);
    const { showMore: t1, showButtonDesign: t2, setShowAll: setShowAll } = t0;
    const showMore = t1 === undefined ? false : t1;
    const showButtonDesign = t2 === undefined ? false : t2;
    const intl = (0, $8C5kA.default)();
    const textKey = showMore ? $8a60fc49afcf0f5b$var$i18n.showMore : $8a60fc49afcf0f5b$var$i18n.showLess;
    const testIdText = showMore ? "more" : "less";
    let t3;
    if ($[0] !== setShowAll || $[1] !== showMore) {
        t3 = (event)=>{
            if (event.key === "Enter") {
                setShowAll(showMore);
                setTimeout($8a60fc49afcf0f5b$var$_temp, 0);
            }
        };
        $[0] = setShowAll;
        $[1] = showMore;
        $[2] = t3;
    } else t3 = $[2];
    const handleKeyDown = t3;
    let t4;
    if ($[3] !== handleKeyDown || $[4] !== intl || $[5] !== setShowAll || $[6] !== showButtonDesign || $[7] !== showMore || $[8] !== testIdText || $[9] !== textKey) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, showButtonDesign ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8a60fc49afcf0f5b$var$StyledButton, {
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($tvI67))), {
                label: ""
            }),
            appearance: "subtle",
            testId: `live-pages-byline-show-${testIdText}`,
            onClick: ()=>setShowAll(showMore)
        }, intl.formatMessage(textKey)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8a60fc49afcf0f5b$var$ShowMoreLess, {
            role: "button",
            onClick: ()=>setShowAll(showMore),
            "data-testid": `byline-show-${testIdText}`,
            tabIndex: 0,
            onKeyDown: handleKeyDown,
            id: "byline-apps-show-more-less-toggle"
        }, intl.formatMessage(textKey)));
        $[3] = handleKeyDown;
        $[4] = intl;
        $[5] = setShowAll;
        $[6] = showButtonDesign;
        $[7] = showMore;
        $[8] = testIdText;
        $[9] = textKey;
        $[10] = t4;
    } else t4 = $[10];
    return t4;
};
function $8a60fc49afcf0f5b$var$_temp() {
    document.getElementById("byline-apps-show-more-less-toggle")?.focus();
}


const $cd6af931b4e9ea04$var$NUMBER_OF_VISIBLE_APPS = 3;
const $cd6af931b4e9ea04$var$LIVE_PAGES_NUMBER_OF_VISIBLE_APPS = 4; // eslint-disable-next-line @compiled/no-exported-css, @compiled/no-css-tagged-template-expression, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/no-css-tagged-template-expression -- Ignored via go/DSP-18766
const $cd6af931b4e9ea04$export$94132a0e348806d4 = null; // eslint-disable-next-line @compiled/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/design-system/no-styled-tagged-template-expression -- Ignored via go/DSP-18766
const $cd6af931b4e9ea04$var$StyledWebItemList = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? (0, $asQED.WebItemList) : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _18s8m31d _10rwidpf _my3jidpf _r8osidpf _aqpeidpf _w5axidpf _13n1idpf _jysiidpf _10e4idpf _3e5g1o8l _wm461o8l _154qazsu _fy3vazsu _uh5d1c8u _101x1r31 _q7leglyw _hxadnqa1 _1pze1mp2 _1oee1o8l _sl7xazsu _11if1r31 _ea6yglyw _1q79nqa1 _151t1rpy _w4kt1ndm _swoy1rpy",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $cd6af931b4e9ea04$var$UFOByLineAppsComponentWrapper = (t0)=>{
    const $ = (0, $frIzR.c)(3);
    const { children: children, name: name, isEmpty: isEmpty } = t0;
    if (!(0, $9wGTI.fg)("confluence_annotate_byline") || isEmpty) return children;
    let t1;
    if ($[0] !== children || $[1] !== name) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iRRvH.UFOThirdPartySegment), {
            name: name
        }, children);
        $[0] = children;
        $[1] = name;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
};
const $cd6af931b4e9ea04$export$127ace2288e0ed63 = ({ contentId: contentId, connectItems: connectItems, forgeItems: forgeItems, onLoad: onLoad, showLivePagesExtensionPoints: showLivePagesExtensionPoints, showLoader: showLoader, isSingleLineByline: isSingleLineByline = false })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const numberOfVisibleApps = showLivePagesExtensionPoints ? $cd6af931b4e9ea04$var$LIVE_PAGES_NUMBER_OF_VISIBLE_APPS : $cd6af931b4e9ea04$var$NUMBER_OF_VISIBLE_APPS;
    const [isShowAll, setShowAll] = (0, $42omo.useState)((0, $17wUi.confluenceLocalStorageInstance).getItemAsBoolean((0, $1UApO.keys).BYLINE_APPS_SHOW_ALL));
    (0, $42omo.useEffect)(()=>{
        (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).BYLINE_APPS_SHOW_ALL, isShowAll);
    }, [
        isShowAll
    ]);
    (0, $42omo.useEffect)(()=>{
        onLoad();
    }, [
        onLoad
    ]);
    (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'rendered',
                actionSubject: 'bylineApps',
                source: 'ByLineAppsComponent',
                attributes: {
                    numberOfApps: connectItems?.length + forgeItems?.length
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        connectItems?.length,
        forgeItems?.length
    ]);
    if (showLoader) // Doing this to prevent flash during live pages SSR hydration step.
    // At this point, the data has been loaded but showLoader is still true since the onLoad is asynchronously setting the showLoader
    // state to false. It will briefly render both the placeholder and the actual content at the same time.
    // Returning null here ensures we only show actual content when the loader is not showing and prevents the flash.
    return null;
    connectItems = connectItems || [];
    forgeItems = forgeItems || [];
    const renderPart = (cApps, fApps, numberOfForgeAppsToShow)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, cApps.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($cd6af931b4e9ea04$var$UFOByLineAppsComponentWrapper, {
            name: "byline-apps-connect-items",
            isEmpty: cApps.length === 0
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($cd6af931b4e9ea04$var$StyledWebItemList, {
            pageId: contentId,
            webItems: cApps,
            ContainerTagName: "span",
            webItemClassName: "bylineWebItem",
            hideDot: showLivePagesExtensionPoints || isSingleLineByline,
            noContainer: isSingleLineByline,
            useBadgeStyles: true
        })) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($cd6af931b4e9ea04$var$UFOByLineAppsComponentWrapper, {
            name: "byline-apps-forge-items",
            isEmpty: fApps.length === 0
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, fApps.map((app, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1cb9b1bda2de2c04$export$d2159b9f3f077903), {
                key: app.id,
                app: app,
                contentId: contentId,
                isHidden: isShowAll ? false : idx >= numberOfForgeAppsToShow,
                setShowAll: setShowAll,
                hideDot: showLivePagesExtensionPoints || isSingleLineByline
            }))))); // single line byline renders all apps initially, hiding them in overflow until user clicks show more button
    // when user clicks show more, they are shown and wrapped to next line
    if (isSingleLineByline) return renderPart(connectItems, forgeItems, connectItems.length + forgeItems.length);
    if (connectItems.length + forgeItems.length <= numberOfVisibleApps) return renderPart(connectItems, forgeItems, forgeItems.length);
    else {
        // We should show the first numberOfVisibleApps apps including Connect and Forge app;
        // however, all Forge apps need to be RENDERED in order for the Forge Keyboard Shortcut listener
        // to be rendered and active. If (Connect app + Forge apps) is greater than numberOfVisibleApps,
        // then we will show the first numberOfVisibleApps Connect and Forge apps, render all the
        // Forge apps, but visually hide the Forge apps that go beyond numberOfVisibleApps.
        const numberOfConnectAppsToRender = Math.min(connectItems.length, numberOfVisibleApps);
        const numberOfForgeAppsToShow_0 = numberOfVisibleApps - numberOfConnectAppsToRender;
        const firstConnectApps = connectItems.slice(0, numberOfConnectAppsToRender);
        const remainingConnectApps = connectItems.slice(numberOfConnectAppsToRender);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, renderPart(firstConnectApps, forgeItems, numberOfForgeAppsToShow_0), isShowAll ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, renderPart(remainingConnectApps, [], 0), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8a60fc49afcf0f5b$export$e5bc424bebb08325), {
            showMore: false,
            showButtonDesign: !!showLivePagesExtensionPoints,
            setShowAll: setShowAll
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8a60fc49afcf0f5b$export$e5bc424bebb08325), {
            showMore: true,
            showButtonDesign: !!showLivePagesExtensionPoints,
            setShowAll: setShowAll
        }));
    }
};
module.exports["ByLineAppsComponent"] = $cd6af931b4e9ea04$export$127ace2288e0ed63;

});

parcelRegister("83fWZ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $a4TK8 = parcelRequire("a4TK8");

const $7a82ae306aa8d2fb$export$656295fdbe704c1d = (obj)=>{
    const ref = (0, $42omo.useRef)(obj);
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(ref.current, obj)) ref.current = obj;
    return ref.current;
};
const $7a82ae306aa8d2fb$export$704cf5548ea2cdcf = (data)=>{
    if (!data) return null;
    if ('singleContent' in data) return null;
    if ('content' in data) {
        const sourceTemplateEntityId = data?.content?.nodes?.[0]?.metadata?.sourceTemplateEntityId || null;
        if (!sourceTemplateEntityId) return null;
        // we don't want to show the powered by template(popup) for the space blueprint
        // blueprints used during space creation should not be exposed to customer as those are internal only
        // internal-only blueprints usually include substring "confluence-space-blueprints" in sourceTemplateEntityId
        return sourceTemplateEntityId.includes('confluence-space-blueprints') ? null : sourceTemplateEntityId;
    }
    return null;
};
const $7a82ae306aa8d2fb$export$3b131fc84567c0ad = (data)=>{
    if (!data) return false;
    if ('singleContent' in data) return false;
    if ('content' in data) {
        const properties = data?.content?.nodes?.[0]?.properties?.nodes || [];
        const editorVersion = properties.find((p)=>p?.key === 'editor');
        return editorVersion?.value?.includes('v2') || false;
    }
    return false;
};
const $7a82ae306aa8d2fb$export$73e2b60bcda446a1 = ({ owner: owner, author: author, lastModifier: lastModifier, contributors: contributors })=>{
    let arrangedContributors = [];
    if (owner !== null) arrangedContributors = [
        // Owner is always shown first
        owner,
        // Then the author
        ...author.userId === owner.userId ? [] : [
            author
        ],
        // Then the last person to have edited, unless they're also the author
        ...lastModifier.userId === author.userId || lastModifier.userId === owner.userId ? [] : [
            lastModifier
        ],
        // Then all the other contributors
        ...contributors.filter(({ userId: userId })=>userId !== author.userId && userId !== lastModifier.userId && userId !== owner.userId)
    ];
    else arrangedContributors = [
        // Author is always shown first
        author,
        // Then the last person to have edited, unless they're also the author
        ...lastModifier.userId === author.userId ? [] : [
            lastModifier
        ],
        // Then all the other contributors
        ...contributors.filter(({ userId: userId })=>userId !== author.userId && userId !== lastModifier.userId)
    ];
    return arrangedContributors;
};
const $7a82ae306aa8d2fb$export$44be1e207a638653 = (graphqlUser)=>({
        isAnonymous: !graphqlUser?.accountId,
        userId: graphqlUser?.accountId ?? undefined,
        fullName: graphqlUser?.displayName,
        avatarUrl: graphqlUser?.profilePicture?.path
    });
module.exports["useMemoizedObj"] = $7a82ae306aa8d2fb$export$656295fdbe704c1d;
module.exports["getSourceTemplateKey"] = $7a82ae306aa8d2fb$export$704cf5548ea2cdcf;
module.exports["isFabricEditor"] = $7a82ae306aa8d2fb$export$3b131fc84567c0ad;
module.exports["getArrangedContributors"] = $7a82ae306aa8d2fb$export$73e2b60bcda446a1;
module.exports["toUserProps"] = $7a82ae306aa8d2fb$export$44be1e207a638653;

});

parcelRegister("35Exc", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $0adb659d8e3039a1$export$c008670b78f0cf4f = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isTitleCenterAligned: isTitleCenterAligned, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_11c8wadc _18s8t1lt _syazazsu _1e0c1txw _4cvr1h6o",
            __cmplp.isTitleCenterAligned ? "_y3gn1h6o" : "_y3gn1kw7",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $0adb659d8e3039a1$export$3ed1f5d7ee09c27 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? $0adb659d8e3039a1$export$c008670b78f0cf4f : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_18s8ze3t _4cvr1h6o _16jlkb7n _1pbyb4wl _o5721q9c",
            !!__cmplp.hasFixedHeight ? "_4t3izwfg" : "_4t3i1wug",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // Note: this component extracts the props that we don't want to send to the DOM
const $0adb659d8e3039a1$var$BylineStyledMainDivSingleLineWrapper = (t0)=>{
    const $ = (0, $frIzR.c)(6);
    let children;
    let props;
    if ($[0] !== t0) {
        const { isExpanded: isExpanded, children: t1, ...t2 } = t0;
        children = t1;
        props = t2;
        $[0] = t0;
        $[1] = children;
        $[2] = props;
    } else {
        children = $[1];
        props = $[2];
    }
    let t1;
    if ($[3] !== children || $[4] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0adb659d8e3039a1$export$3ed1f5d7ee09c27, props, children);
        $[3] = children;
        $[4] = props;
        $[5] = t1;
    } else t1 = $[5];
    return t1;
}; /* eslint-enable @typescript-eslint/no-unused-vars */ 
const $0adb659d8e3039a1$export$b95808ab42b44324 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? $0adb659d8e3039a1$var$BylineStyledMainDivSingleLineWrapper : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1bsb1osq _kqswh2mm _1pby1wug",
            __cmplp.isExpanded ? "_7yjrt94y" : "_7yjridpf",
            __cmplp.isExpanded ? "_1r3z1n1a" : "_1r3zidpf",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $0adb659d8e3039a1$export$9688ba18a24c9efa = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isTitleCenterAligned: isTitleCenterAligned, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "",
            __cmplp.isTitleCenterAligned ? "_19pkidpf _2hwx1v6z _otyridpf _18u0idpf" : "_19pk1l7b _2hwxidpf _otyridpf _18u0idpf",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $0adb659d8e3039a1$export$6a3337cf751e21ac = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { hasBadgeStylePageOwnerBylineItem: hasBadgeStylePageOwnerBylineItem, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1bsb1osq _59381r31 _yha2glyw _1nmznqa1 _43ds13af _7hxb1r31 _9m7f1r31 _rfqo1r31 _qfs11r31 _15zv8stv _w7sw8stv _1bgk8stv _s41o8stv _1xvinqa1 _15a9nqa1 _1t0pnqa1 _1k6pnqa1 _p03c12zz _oavv12zz _oxk412zz _1cay12zz",
            !!__cmplp.hasBadgeStylePageOwnerBylineItem ? "_19pkidpf _2hwxidpf _otyridpf _18u0idpf" : "_18s8171m",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $0adb659d8e3039a1$export$5237d2d172029aad = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? $0adb659d8e3039a1$export$6a3337cf751e21ac : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw _4cvr1h6o _19pkv77o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $0adb659d8e3039a1$export$83c328dc4b257f5e = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isTitleCenterAligned: isTitleCenterAligned, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_m31q1r31 _5xsmglyw _u1kenqa1 _7qx013af _7hxb1r31 _9m7f1r31 _rfqo1r31 _qfs11r31 _15zv8stv _w7sw8stv _1bgk8stv _s41o8stv _1xvinqa1 _15a9nqa1 _1t0pnqa1 _1k6pnqa1 _p03c12zz _oavv12zz _oxk412zz _1cay12zz",
            __cmplp.isTitleCenterAligned ? "_1e0c1txw" : "_1e0c1ule",
            __cmplp.isTitleCenterAligned ? "_1bah1h6o" : "_1bah4jg8",
            __cmplp.isTitleCenterAligned ? "_4cvr1h6o" : "_4cvr4jg8",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $0adb659d8e3039a1$export$f722050c7393dc5a = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_11q7izff _2rkofajl _1e0c1o8l _1bsb53f4 _4t3idlk8",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
module.exports["StyledMainDiv"] = $0adb659d8e3039a1$export$c008670b78f0cf4f;
module.exports["BylineStyledMainDivSingleLine"] = $0adb659d8e3039a1$export$b95808ab42b44324;
module.exports["StyledAvatars"] = $0adb659d8e3039a1$export$9688ba18a24c9efa;
module.exports["StyledTextDiv"] = $0adb659d8e3039a1$export$6a3337cf751e21ac;
module.exports["StyledAuthorDiv"] = $0adb659d8e3039a1$export$83c328dc4b257f5e;
module.exports["StyledNameSkeleton"] = $0adb659d8e3039a1$export$f722050c7393dc5a;

});


//# sourceMappingURL=EditorByLineArea.14761e76.js.map
